(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["catalog-card"] && !Shopify.designMode) return;
  try {
    /* touch-reveal · נגיעה אחת חושפת את תמונת המרכיבים + ה-CTA (מכשירי מגע בלבד).
   הוא חי כאן ולא בסקשן: בלוקי javascript מקומפלים ל-scripts.js (סקשנים) ול-
   snippet-scripts.js (סניפטים) עם שער `if (__sections__/__snippets__[name])`,
   ולכן קוד ברמת-סקשן לא רץ בעמוד שלא מרנדר את הסקשן. הסניפט הזה מרונדר בשלושת
   העמודים ⇒ זהו הבית היחיד שמכסה את כולם בלי שכפול.
   scope: .catalog בלבד — כרטיסי glow-related-products ב-PDP נושאים את אותן מחלקות
   אך אינם בתוך .catalog, ולכן אינם מושפעים (התנהגות זהה לקוד שקדם). */
(function () {
  if (window.glowCatalogTouchReveal) return;
  if (window.matchMedia('(hover: hover)').matches) return;
  window.glowCatalogTouchReveal = true;

  document.addEventListener('click', function (event) {
    const media = event.target.closest('.catalog-card__media');
    if (!media) return;
    const scope = media.closest('.catalog');
    if (!scope) return;
    if (event.target.closest('.catalog-card__cta-btn')) return;

    const wasRevealed = media.classList.contains('is-revealed');
    for (const other of scope.querySelectorAll('.catalog-card__media.is-revealed')) {
      if (other !== media) other.classList.remove('is-revealed');
    }
    media.classList.toggle('is-revealed', !wasRevealed);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["catalog-mega-menu"] && !Shopify.designMode) return;
  try {
    class CatalogMega extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleTileClick.bind(this));
  }

  handleTileClick(event) {
    const link = event.target.closest('a.catalog-mega__tile');
    if (!link) return;
    this.closeNav();
  }

  closeNav() {
    const openParent = this.closest('.navigation__item--show-children');
    if (openParent) {
      openParent.classList.remove('navigation__item--show-children');
      const section = this.closest('.section-header');
      if (section) section.classList.remove('section-header--nav-open');
    }
    if (document.body.classList.contains('reveal-mobile-nav')) {
      const toggle = document.querySelector('.mobile-navigation-drawer .mobile-nav-toggle')
        || document.querySelector('.mobile-nav-toggle');
      if (toggle) {
        toggle.click();
      } else {
        document.body.classList.remove('reveal-mobile-nav', 'reveal-mobile-nav--revealed');
      }
    }
  }
}

if (!customElements.get('catalog-mega')) {
  customElements.define('catalog-mega', CatalogMega);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glow-cart-rescue"] && !Shopify.designMode) return;
  try {
    class GlowCartRescue extends HTMLElement {
    /* דגל הקליק (נכתב ב-glow-cart.js) + דגלי פעם-בסשן */
    #flagKey = 'glow_rescue';
    #shownKey = 'glow_rescue_shown';
    #retKey = 'glow_rescue_ret';
    #freshMs = 30 * 60 * 1000;
    #hubBase = 'https://glow-customer-hub.glowvitamininsights.workers.dev';
    #lastFocused = null;
    #variant = 'a';
    #flag = null;
    #cart = null;
    #gateDone = false;
    #retryId = 0;

    connectedCallback() {
      this.overlay = this.querySelector('[data-glow-cr-overlay]');
      this.panel = this.querySelector('[data-glow-cr-panel]');
      this.formView = this.querySelector('[data-glow-cr-form-view]');
      this.thanksView = this.querySelector('[data-glow-cr-thanks-view]');
      this.form = this.querySelector('[data-glow-cr-form]');
      this.errEl = this.querySelector('[data-glow-cr-err]');

      this.querySelectorAll('[data-glow-cr-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });
      this.overlay?.addEventListener('click', (event) => {
        if (event.target === this.overlay) this.close();
      });
      this.addEventListener('keydown', this.#onKeydown.bind(this));
      this.form?.addEventListener('submit', this.#onSubmit.bind(this));

      /* הגייט רץ גם על load רגיל וגם על שחזור מ-bfcache (חזרה "אחורה" מהקופה
         מציגה את הדף מהזיכרון בלי load · pageshow persisted הוא הרגע היחיד שלנו). */
      const gate = () => this.#gate();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', gate);
      } else {
        gate();
      }
      window.addEventListener('pageshow', (e) => { if (e.persisted) { this.#gateDone = false; gate(); } });
    }

    #readFlag() {
      try {
        const raw = sessionStorage.getItem(this.#flagKey);
        if (!raw) return null;
        const f = JSON.parse(raw);
        if (!f || !f.ts || Date.now() - Number(f.ts) > this.#freshMs) return null;
        /* נירמול גם בקריאה: סשן שהתחיל לפני ה-deploy נושא דגל ישן עם "?key=" חתוך
           (עד 30 דק'). כך גם הוא מתאחה נכון במקום ליפול בוולידציה של ה-Hub. */
        f.token = this.#normToken(f.token) || null;
        return f;
      } catch (e) { return null; }
    }

    #knownEmail() {
      try { return localStorage.getItem('glow_known_email') || ''; } catch (e) { return ''; }
    }

    #once(key) {
      try {
        if (sessionStorage.getItem(key)) return false;
        sessionStorage.setItem(key, '1');
        return true;
      } catch (e) { return false; }
    }

    /* beacon מדידה · רשומות המשפך xp:* (returned/shown) ב-Hub. לא-קריטי. */
    #track(stage) {
      try {
        if (!this.#flag || !this.#flag.token) return;
        const payload = new Blob(
          [JSON.stringify({ stage: stage, token: this.#flag.token })],
          { type: 'text/plain' }
        );
        let sent = false;
        try { sent = !!(navigator.sendBeacon && navigator.sendBeacon(this.#hubBase + '/rescue-track', payload)); } catch (e) { sent = false; }
        if (!sent) fetch(this.#hubBase + '/rescue-track', { method: 'POST', keepalive: true, mode: 'no-cors', body: payload }).catch(() => {});
      } catch (e) { /* לא-קריטי */ }
    }

    #gate() {
      if (this.#gateDone) return;
      this.#gateDone = true;
      this.#flag = this.#readFlag();
      if (!this.#flag) return;

      /* חזרה-מהקופה אמיתית (דגל טרי) · נמדדת פעם אחת לסשן, גם אם הפופאפ לא יוצג */
      if (this.#once(this.#retKey)) this.#track('returned');

      let shown = false;
      try { shown = !!sessionStorage.getItem(this.#shownKey); } catch (e) { shown = false; }
      if (shown) return;
      if (this.#knownEmail()) return; /* מנויה מוכרת · המיילים כבר יגיעו אליה, בלי פופאפ */

      /* עגלה מלאה + מצב-קוד עדכני (הגרסה נקבעת לפי העגלה עכשיו, לא לפי רגע הקליק) */
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((cart) => {
          if (!cart || !cart.item_count) return;
          this.#cart = cart;
          let hasCode = !!(this.#flag && this.#flag.hasCode);
          try {
            const apps = Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : [];
            if (apps.some((a) => a && a.type === 'discount_code')) hasCode = true;
          } catch (e) { /* נשאר לפי הדגל */ }
          this.#variant = hasCode ? 'b' : 'a';
          window.GlowAttention?.want('rescue');
          setTimeout(() => this.#tryOpen(), 700);
        })
        .catch(() => {});
    }

    /* תיאום (30.09 · snippets/glow-attention.liquid): לא קופצים על באנר עוגיות / מסנג'ר / מגירה / אלמנט
       יזום אחר. עסוק = ניסיון נוסף כל 2 שניות, עד שהפופאפ מוצג או שהדגל התיישן (30 דק'). */
    #tryOpen() {
      if (!this.hidden) return;
      let shown = false;
      try { shown = !!sessionStorage.getItem(this.#shownKey); } catch (e) { shown = false; }
      const att = window.GlowAttention;
      if (shown || !this.#readFlag()) {
        att?.want('rescue', false);
        return;
      }
      const busy = att ? att.busyReason(this) : '';
      if (busy) {
        att.log(`הצלת העגלה ממתינה: ${busy}`);
        clearTimeout(this.#retryId);
        this.#retryId = setTimeout(() => this.#tryOpen(), 2000);
        return;
      }
      this.open();
    }

    #applyVariant() {
      const a = this.#variant === 'a';
      this.querySelectorAll('[data-glow-cr-a]').forEach((el) => { el.hidden = !a; });
      this.querySelectorAll('[data-glow-cr-b]').forEach((el) => { el.hidden = a; });
    }

    open() {
      if (!this.hidden) return;
      /* אין שני פופאפים באותו ביקור · אם פופאפ המועדון כבר פתוח, מוותרים בשקט */
      const nl = document.querySelector('glow-newsletter-popup');
      if (nl && !nl.hidden) return;
      /* R1 + R4 במתאם: תור יחיד, והתראות Intercom וה-launcher מוסתרים כל עוד המודאל פתוח */
      const att = window.GlowAttention;
      if (att && !att.claim('rescue', { modal: true })) {
        clearTimeout(this.#retryId);
        this.#retryId = setTimeout(() => this.#tryOpen(), 2000);
        return;
      }
      this.#applyVariant();
      this.#lastFocused = document.activeElement;
      this.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      try { sessionStorage.setItem(this.#shownKey, '1'); } catch (e) { /* incognito */ }
      this.#track('shown');
      requestAnimationFrame(() => {
        const email = this.querySelector('#glow-cr-email');
        if (email) email.focus();
        else this.panel?.focus();
      });
    }

    close() {
      if (this.hidden) return;
      this.hidden = true;
      document.documentElement.style.overflow = '';
      window.GlowAttention?.release('rescue');
      if (this.#lastFocused && typeof this.#lastFocused.focus === 'function') {
        this.#lastFocused.focus();
      }
    }

    #showErr(msg) {
      if (!this.errEl) return;
      this.errEl.textContent = msg;
      this.errEl.hidden = false;
    }

    /* טלפון ישראלי → E.164 ‏(+9725XXXXXXXX). ריק = תקין (אופציונלי); פורמט שגוי = null. */
    #normalizePhone(raw) {
      const digits = String(raw || '').replace(/[\s\-().]/g, '');
      if (!digits) return '';
      if (/^05\d{8}$/.test(digits)) return '+972' + digits.slice(1);
      if (/^\+9725\d{8}$/.test(digits)) return digits;
      if (/^9725\d{8}$/.test(digits)) return '+' + digits;
      return null;
    }

    /* 🔴 נירמול token העגלה (נתפס ב-E2E סטייג'ינג 19.8): cart.token מ-/cart.js מגיע
       כ-"hWNFqEChC4qQjZ6gVtLTg7Rz?key=bfc5793089a…", בעוד ה-webhooks של שופיפיי
       מדווחים token נקי. חותכים ב-"?" לפני ה-slice · אחרת חותכים באמצע ה-key,
       וה-Hub פוסל את ה-token (tokenOk) והפופאפ נופל. מתודה פרטית = בלי שם גלובלי
       שיכול להתנגש בבאנדל ה-JS המשותף של התמה. */
    #normToken(raw) {
      return String(raw == null ? '' : raw).split('?')[0].slice(0, 40);
    }

    #cartPayload() {
      const c = this.#cart || {};
      return {
        items: (c.items || []).map((i) => ({
          title: i.product_title,
          qty: i.quantity,
          unit_price: Math.round((typeof i.final_price === 'number') ? i.final_price : (i.price || 0)) / 100,
          line_price: Math.round((typeof i.final_line_price === 'number') ? i.final_line_price : (i.line_price || 0)) / 100,
          image: i.image || null,
          variant_id: i.id || null,
          url: i.url || null
        })),
        count: c.item_count || 0,
        original_total: Math.round(c.original_total_price || 0) / 100,
        discount: Math.round(c.total_discount || 0) / 100,
        total: Math.round(c.total_price || 0) / 100,
        currency: c.currency || 'ILS',
        token: this.#normToken(c.token) || null
      };
    }

    #onSubmit(event) {
      event.preventDefault();
      if (this.errEl) this.errEl.hidden = true;

      const emailEl = this.querySelector('#glow-cr-email');
      const phoneEl = this.querySelector('#glow-cr-phone');
      const consentEl = this.querySelector('#glow-cr-wa-consent');
      const btn = this.querySelector('[data-glow-cr-submit]');
      const email = String((emailEl && emailEl.value) || '').trim().toLowerCase();

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.#showErr('נשמח למייל תקין כדי לשמור לך את העגלה');
        if (emailEl) emailEl.focus();
        return;
      }
      const phone = this.#normalizePhone(phoneEl && phoneEl.value);
      if (phone === null) {
        this.#showErr('המספר לא נראה תקין · אפשר גם להשאיר את השדה ריק');
        if (phoneEl) phoneEl.focus();
        return;
      }
      if (btn && btn.getAttribute('aria-busy') === 'true') return;
      if (btn) btn.setAttribute('aria-busy', 'true');

      const body = {
        email: email,
        phone: phone || null,
        waConsent: !!(phone && consentEl && consentEl.checked),
        variant: this.#variant,
        token: (this.#flag && this.#flag.token) || null,
        cart: this.#cartPayload(),
        page: location.pathname
      };

      /* text/plain = simple request (בלי preflight) · ה-Hub עונה עם CORS ל-origin שלנו */
      fetch(this.#hubBase + '/rescue', {
        method: 'POST',
        headers: { 'content-type': 'text/plain' },
        body: JSON.stringify(body)
      })
        .then((r) => (r.ok ? r.json() : null))
        .then((res) => {
          if (btn) btn.removeAttribute('aria-busy');
          if (!res || !res.ok) {
            this.#showErr('משהו השתבש רגעית · נסי שוב עוד שנייה');
            return;
          }
          try { localStorage.setItem('glow_known_email', email); } catch (e) { /* private mode */ }
          try { sessionStorage.removeItem(this.#flagKey); } catch (e) { /* noop */ }
          if (this.formView) this.formView.hidden = true;
          if (this.thanksView) {
            this.thanksView.hidden = false;
            this.#applyVariant();
          }
          /* אנליטיקה · glow_lead (source:'rescue'), לא-קריטי */
          try {
            if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
              window.Shopify.analytics.publish('glow_lead', { source: 'rescue' });
            }
          } catch (e) { /* noop */ }
          requestAnimationFrame(() => {
            const done = this.thanksView && this.thanksView.querySelector('[data-glow-cr-close]');
            if (done) done.focus();
          });
        })
        .catch(() => {
          if (btn) btn.removeAttribute('aria-busy');
          this.#showErr('אין חיבור כרגע · נסי שוב עוד רגע');
        });
    }

    #focusable() {
      return Array.from(
        this.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => el.offsetParent !== null);
    }

    #onKeydown(event) {
      if (this.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;
      const items = this.#focusable();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('glow-cart-rescue')) {
    customElements.define('glow-cart-rescue', GlowCartRescue);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glow-cookie-banner"] && !Shopify.designMode) return;
  try {
    class GlowCookieBanner extends HTMLElement {
    #root = document.documentElement;
    #storageKey = 'glow_cookie_consent';
    #maxAgeMs = 365 * 24 * 60 * 60 * 1000;

    connectedCallback() {
      this.acceptBtn = this.querySelector('[data-glow-cookie-accept]');
      this.essentialBtn = this.querySelector('[data-glow-cookie-essential]');

      this.acceptBtn?.addEventListener('click', () => this.#decide(true));
      this.essentialBtn?.addEventListener('click', () => this.#decide(false));

      document.addEventListener('click', this.#onSettingsClick.bind(this));

      window.glowOpenCookieSettings = () => this.open();

      const decision = this.#readDecision();
      if (decision) {
        this.#applyConsent(decision === 'granted');
      } else {
        this.open();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.#onSettingsClick.bind(this));
      this.observer?.disconnect();
    }

    #onSettingsClick(event) {
      const trigger = event.target.closest('[data-glow-cookie-settings]');
      if (!trigger) return;
      event.preventDefault();
      this.open();
    }

    #readDecision() {
      try {
        const raw = localStorage.getItem(this.#storageKey);
        if (!raw) return null;
        const data = JSON.parse(raw);
        if (!data || !data.ts || !data.choice) return null;
        if (Date.now() - data.ts >= this.#maxAgeMs) return null;
        return data.choice;
      } catch (error) {
        return null;
      }
    }

    #store(choice) {
      try {
        localStorage.setItem(this.#storageKey, JSON.stringify({ choice: choice, ts: Date.now() }));
      } catch (error) {
        /* localStorage unavailable - fail silently, banner will reappear next visit */
      }
    }

    #applyConsent(granted) {
      const consent = granted
        ? { analytics: true, marketing: true, preferences: true, sale_of_data: false }
        : { analytics: false, marketing: false, preferences: false, sale_of_data: false };

      const apply = () => {
        try {
          window.Shopify.customerPrivacy.setTrackingConsent(consent, () => {});
        } catch (error) {
          /* API not ready - consent still stored locally */
        }
      };

      if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
        apply();
      } else if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          (error) => {
            if (!error) apply();
          }
        );
      }
    }

    #decide(granted) {
      this.#applyConsent(granted);
      this.#store(granted ? 'granted' : 'essential');
      this.close();
    }

    open() {
      this.hidden = false;
      requestAnimationFrame(() => this.#syncHeight());
      if (!this.observer && 'ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.#syncHeight());
        this.observer.observe(this);
      }
    }

    close() {
      this.hidden = true;
      this.#root.classList.remove('glow-cookie-banner-visible');
      this.#root.style.setProperty('--glow-cookie-banner-h', '0px');
      this.observer?.disconnect();
      this.observer = null;
    }

    #syncHeight() {
      if (this.hidden) return;
      const gap = 16;
      const total = Math.ceil(this.getBoundingClientRect().height) + gap;
      this.#root.classList.add('glow-cookie-banner-visible');
      this.#root.style.setProperty('--glow-cookie-banner-h', total + 'px');
    }
  }

  if (!customElements.get('glow-cookie-banner')) {
    customElements.define('glow-cookie-banner', GlowCookieBanner);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glow-daniela-opener"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('glow-daniela-opener')) return;

    /* gdo-logic:start · לוגיקה טהורה (בלי DOM): מפות העדשה של L2 והרוחב לצד ה-FAB.
       נבדקת ב-tests/glow-daniela-opener.test.mjs, שמחלץ את הקטע הזה בין שני הסמנים. */
    const GdoLogic = (() => {
      /* גוף העדשה של L2 (gen_wow.py · v3, הטון הבהיר) */
      const LENS = { sat: 1.2, e: 0.92, o: 0.03 };
      function clamp01(v) {
        return v < 0 ? 0 : v > 1 ? 1 : v;
      }

      /* ── מפת העדשה · פורט של lensmap.py: squircle קמור, Snell n=1.5, נורמל פנימה, 1px חיצוני מדועך ── */
      function lensProfile(bezel, thick, n = 1.5, samples = 256) {
        const t = new Float64Array(samples);
        const y = new Float64Array(samples);
        for (let i = 0; i < samples; i += 1) {
          t[i] = i / (samples - 1);
          y[i] = (1 - (1 - t[i]) ** 4) ** 0.25;
        }
        const disp = new Float64Array(samples);
        for (let i = 0; i < samples; i += 1) {
          const a = i === 0 ? 0 : i - 1;
          const b = i === samples - 1 ? samples - 1 : i + 1;
          const slope = ((y[b] - y[a]) / (t[b] - t[a])) * (thick / bezel);
          const theta = Math.atan(slope);
          const theta2 = Math.asin(Math.sin(theta) / n);
          disp[i] = i === 0 ? 0 : y[i] * thick * Math.tan(theta - theta2);
        }
        return { t, disp };
      }
      function interp(x, t, v) {
        const n = t.length - 1;
        const f = clamp01(x) * n;
        const i = Math.min(n - 1, Math.floor(f));
        const k = f - i;
        return v[i] * (1 - k) + v[i + 1] * k;
      }
      function sdRoundBox(px, py, hw, hh, r) {
        const rx = px > 0 ? (py > 0 ? r[1] : r[0]) : py > 0 ? r[2] : r[3];
        const qx = Math.abs(px) - hw + rx;
        const qy = Math.abs(py) - hh + rx;
        return Math.min(Math.max(qx, qy), 0) + Math.hypot(Math.max(qx, 0), Math.max(qy, 0)) - rx;
      }
      /* radii פיזיים [tl, tr, br, bl] · מחזיר RGBA: R/G = תזוזה (128 = אפס), B = מסכת השפה · max = התזוזה המקסימלית ב-px */
      function lensMap(w, h, radii, bezel, ss = 1.5) {
        const W = Math.max(2, Math.round(w * ss));
        const H = Math.max(2, Math.round(h * ss));
        const lim = Math.min(w, h) / 2;
        const r = [radii[1], radii[2], radii[3], radii[0]].map((v) => Math.min(lim, Math.max(0, v)));
        const d = new Float32Array(W * H);
        for (let j = 0; j < H; j += 1) {
          const py = (j + 0.5) / ss - h / 2;
          for (let i = 0; i < W; i += 1) d[j * W + i] = sdRoundBox((i + 0.5) / ss - w / 2, py, w / 2, h / 2, r);
        }
        const thick = bezel * 1.6;
        const prof = lensProfile(bezel, thick);
        const mag = new Float32Array(W * H);
        const nx = new Float32Array(W * H);
        const ny = new Float32Array(W * H);
        let mx = 0;
        for (let j = 0; j < H; j += 1) {
          for (let i = 0; i < W; i += 1) {
            const k = j * W + i;
            const dist = -d[k];
            if (dist <= 0) continue;
            const i0 = i === 0 ? i : i - 1;
            const i1 = i === W - 1 ? i : i + 1;
            const j0 = j === 0 ? j : j - 1;
            const j1 = j === H - 1 ? j : j + 1;
            const gx = (d[j * W + i1] - d[j * W + i0]) / ((i1 - i0) / ss);
            const gy = (d[j1 * W + i] - d[j0 * W + i]) / ((j1 - j0) / ss);
            const gn = Math.hypot(gx, gy) + 1e-9;
            nx[k] = -gx / gn;
            ny[k] = -gy / gn;
            const m = interp(dist / bezel, prof.t, prof.disp) * Math.min(1, dist);
            mag[k] = m;
            if (m > mx) mx = m;
          }
        }
        const data = new Uint8ClampedArray(W * H * 4);
        const rimBand = bezel * 0.55;
        for (let k = 0; k < W * H; k += 1) {
          const dist = -d[k];
          const m = mx > 0 ? mag[k] / mx : 0;
          const rim = dist > 0 ? clamp01(1 - dist / rimBand) ** 2 : 0;
          data[k * 4] = Math.round(128 + nx[k] * m * 127);
          data[k * 4 + 1] = Math.round(128 + ny[k] * m * 127);
          data[k * 4 + 2] = Math.round(128 + rim * 127);
          data[k * 4 + 3] = 255;
        }
        return { width: W, height: H, data, max: mx };
      }
      function lensKey(w, h, radii, bezel, ss = 1.5) {
        return [Math.round(w), Math.round(h)]
          .concat(radii.map((v) => Math.round(v * 2) / 2), [bezel, ss])
          .join('_')
          .replace(/[^0-9_]/g, 'p');
      }
      /* גוף העדשה: g = O + (1-O) * x^E לכל ערוץ (הרמה עדינה ונאמנה לגוון) · 33 דגימות ל-feFunc table */
      function calmTable(n = 33) {
        const out = [];
        for (let i = 0; i < n; i += 1) out.push(+(LENS.o + (1 - LENS.o) * (i / (n - 1)) ** LENS.e).toFixed(3));
        return out.join(' ');
      }

      /* כל האפשרויות תמיד: כשה-FAB של הנגישות בצד הרחוק של הפתיח, הרוחב (מהקצה של המסך) שמשאיר אותו גלוי
         לצד הפתיח. FAB באותו צד שאליו הפתיח מעוגן ⇒ 0 (אין צמצום שעוזר, ה-FAB נשאר מחסום גובה) */
      function farInset(fab, viewportW, openerOnLeft, gap) {
        if (!fab || !(fab.right > fab.left)) return 0;
        const fabOnLeft = (fab.left + fab.right) / 2 < viewportW / 2;
        if (fabOnLeft === openerOnLeft) return 0;
        return Math.ceil(fabOnLeft ? fab.right + gap : viewportW - fab.left + gap);
      }

      /* הנסיגות כשהסט המלא לא נכנס לגובה, לפי הסדר (מצטברות): לצד ה-FAB רק כשה-FAB באמת חוסם מלמעלה,
         וגריד של 2 עמודות רק בדסקטופ (במובייל הוא כבר גריד). אחריהן: ממתינים לגובה */
      function fitSteps(narrow, fabBarrier) {
        const steps = [];
        if (fabBarrier) steps.push('beside-fab');
        if (!narrow) steps.push('compact');
        return steps;
      }

      return { LENS, farInset, fitSteps, lensProfile, lensMap, lensKey, calmTable };
    })();
    /* gdo-logic:end */

    const KEY_PAGEVIEWS = 'glow_opener_pv';
    const KEY_DONE = 'glow_opener_done';
    const KEY_VIEW_SENT = 'glow_opener_view_sent';
    const KEY_QA = 'glow_opener_qa';
    const LEGACY_LOCAL_KEYS = ['glow_opener_group', 'glow_opener_snooze_until'];
    const LEGACY_SESSION_KEYS = ['glow_opener_holdout_sent'];

    const BOOT_DEADLINE_MS = 45000;
    const BOOT_POLL_MS = 400;
    const FIRST_VIEW_AT_MS = 15000;
    const REPEAT_VIEW_AT_MS = 4000;
    const REPEAT_VIEW_MIN_WAIT_MS = 1200;
    const QA_SHOW_AT_MS = 2000;
    const QA_MIN_WAIT_MS = 400;
    const BLOCKED_RETRY_MS = 2000;
    const WATCH_MS = 800;
    const GAP_PX = 14;
    const GAP_PX_NARROW = 14;
    const EDGE_PX = 16;
    const SIDE_NARROW = 16;
    const FAR_DEFAULT = 16;
    /* מרווח בין הפתיח ל-FAB של הנגישות כשהפתיח מצטמצם לידו */
    const FAB_GAP = 8;
    const LEAVE_MS = 220;
    const SWIPE_CLOSE_PX = 56;
    /* שיחה אחת: כמה מחכים לרשימת השיחות / לתיבת ההקלדה לפני שעוברים לשיחה חדשה, וכמה למזהה של שיחה חדשה */
    const APPEND_WAIT_MS = 3500;
    const NEW_WAIT_MS = 10000;
    /* נקודת השבירה של התמה (767.98 / 768), זהה ל-CSS */
    const NARROW = window.matchMedia('(max-width: 767.98px)');
    /* L2 (רפרקציה): רק דסקטופ עם עכבר. במובייל אין רפרקציה בשום מנוע */
    const LENS_MQ = window.matchMedia('(min-width: 768px) and (pointer: fine)');
    const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
    const L0_MQ = window.matchMedia('(prefers-reduced-transparency: reduce), (prefers-contrast: more), (forced-colors: active)');
    const L0_CLASSES = ['a11y-grayscale', 'a11y-mono', 'a11y-contrast-invert', 'a11y-contrast-high'];

    /* ציר הזמן של v3 (שניות מההצגה) */
    const T_GOO = 1.4;
    const T_STEP = 0.075;
    const T_MAT = 0.42;
    const T_X = 1.3;
    const T_TEXT_SEEN = 1.6;
    const T_REDUCED_LIVE = 0.3;
    /* העדשה (gen_wow.py · desktop) */
    const LENS_STRENGTH = 1.75;
    const LENS_FROST = 1.6;
    const LENS_SS = 1.5;
    const LENS_DEBOUNCE_MS = 120;

    const DONE_REASONS = {
      shown: 'הפתיח כבר הוצג בסשן הזה',
      dismissed: 'הפתיח נסגר (X / Escape / החלקה) בסשן הזה',
      clicked: 'כבר נלחצה גלולה בסשן הזה',
      messenger: 'המסנג\'ר נפתח בסשן הזה'
    };

    const INTERCOM_STATES = {
      missing: 'Intercom עוד לא נטען (אין window.Intercom)',
      'not-booted': 'Intercom לא booted',
      'lightweight-jwt': 'Intercom תקוע על lightweight עם לקוחה מחוברת (JWT) · ממתין לריפוי של glow-intercom-fallback',
      'no-launcher': 'Intercom booted אבל אין launcher בדף'
    };

    const storage = {
      get(area, key) {
        try { return window[area].getItem(key); } catch (e) { return null; }
      },
      set(area, key, value) {
        try { window[area].setItem(key, value); return true; } catch (e) { return false; }
      },
      remove(area, key) {
        try { window[area].removeItem(key); } catch (e) { /* storage חסום */ }
      }
    };

    function storageUsable() {
      const probe = 'glow_opener_probe';
      try {
        sessionStorage.setItem(probe, '1');
        sessionStorage.removeItem(probe);
        return true;
      } catch (e) {
        return false;
      }
    }

    function dropLegacyKeys() {
      for (const key of LEGACY_LOCAL_KEYS) storage.remove('localStorage', key);
      for (const key of LEGACY_SESSION_KEYS) storage.remove('sessionStorage', key);
    }

    function readQaFlags() {
      let flags = (storage.get('sessionStorage', KEY_QA) || '').split(' ').filter(Boolean);
      try {
        const param = new URL(window.location.href).searchParams.get('gdo');
        if (param !== null) {
          const parts = param.toLowerCase().split(/[\s,+]+/).filter(Boolean);
          if (parts.includes('off')) {
            flags = [];
          } else {
            for (const part of parts) {
              if ((part === 'show' || part === 'debug' || part === 'flat') && !flags.includes(part)) flags.push(part);
            }
          }
          if (flags.length) {
            storage.set('sessionStorage', KEY_QA, flags.join(' '));
          } else {
            storage.remove('sessionStorage', KEY_QA);
          }
        }
      } catch (e) { /* URL לא תקין · נשארים עם מה שבסשן */ }
      return { show: flags.includes('show'), debug: flags.includes('debug'), flat: flags.includes('flat') };
    }

    function makeLogger(enabled) {
      let last = '';
      return (message) => {
        if (!enabled || message === last) return;
        last = message;
        try { console.info(`[glow-opener] ${message}`); } catch (e) { /* אין קונסול */ }
      };
    }

    function bumpPageViews() {
      const next = (parseInt(storage.get('sessionStorage', KEY_PAGEVIEWS) || '0', 10) || 0) + 1;
      storage.set('sessionStorage', KEY_PAGEVIEWS, String(next));
      return next;
    }

    function publish(name, data) {
      try {
        const analytics = window.Shopify && window.Shopify.analytics;
        if (!analytics || typeof analytics.publish !== 'function') return;
        analytics.publish(name, data);
      } catch (e) { /* אנליטיקס לעולם לא שובר UX */ }
    }

    function publishOncePerSession(flagKey, name, data) {
      if (storage.get('sessionStorage', flagKey)) return;
      if (!storage.set('sessionStorage', flagKey, '1')) return;
      publish(name, data);
    }

    function intercomState() {
      if (typeof window.Intercom !== 'function') return 'missing';
      if (window.Intercom.booted !== true) return 'not-booted';
      if (document.querySelector('iframe[name="intercom-launcher-frame"], iframe[name="intercom-messenger-frame"], iframe[name="intercom-notification-stack-frame"]')) return 'ready';
      if (document.querySelector('.intercom-lightweight-app-launcher')) {
        const jwt = window.intercomSettings && window.intercomSettings.intercom_user_jwt;
        return jwt ? 'lightweight-jwt' : 'ready';
      }
      return 'no-launcher';
    }

    function intercom(...args) {
      try {
        if (typeof window.Intercom === 'function') window.Intercom(...args);
      } catch (e) { /* הצ'אט לא מפיל את הדף */ }
    }

    /* ── שיחה אחת (הכרעת עילי 30.09): הלחיצה נכנסת לשיחה הקיימת ──
       ב-JS API של Intercom אין מתודה ששולחת לשיחה קיימת (startConversation = תמיד שיחה חדשה). לכן: המצב של
       Intercom עצמו (localStorage intercom.intercom-state-<app>) נותן את מזהי השיחות, showConversation(id) פותח
       את האחרונה, והטקסט נכנס לעורך (Lexical, בפריים same-origin) ונשלח בכפתור השליחה. כל כשל לפני השליחה ⇒
       startConversation כמו קודם, ואז מוודאים שהחלון מציג את השיחה החדשה (ולא את הקודמת, הבאג של 30.09). */
    const EDITOR_SEL = '[data-testid="rich-text-editor-content"][contenteditable="true"]';
    const SEND_SEL = '.intercom-composer-send-button';

    function messengerStore() {
      try {
        const appId = window.intercomSettings && window.intercomSettings.app_id;
        const key = appId ? `intercom.intercom-state-${appId}` : Object.keys(localStorage).find((k) => k.startsWith('intercom.intercom-state-'));
        return key ? JSON.parse(localStorage.getItem(key) || 'null') : null;
      } catch (e) {
        return null;
      }
    }

    function conversationIds(store) {
      const byId = store && store.conversations && store.conversations.byId;
      return byId ? Object.keys(byId).filter((id) => /^\d+$/.test(id)) : [];
    }

    /* מזהי שיחה של Intercom עולים עם הזמן: המספר הגדול = האחרונה */
    function latestConversation(ids) {
      return ids.reduce((best, id) => (!best || id.length > best.length || (id.length === best.length && id > best) ? id : best), '');
    }

    function messengerPath(store) {
      const loc = store && store.router && store.router.location;
      return (loc && loc.pathname) || '';
    }

    function messengerFrame() {
      return document.querySelector('iframe[name="intercom-messenger-frame"]');
    }

    function messengerDoc() {
      const frame = messengerFrame();
      try {
        return frame ? frame.contentDocument : null;
      } catch (e) {
        return null;
      }
    }

    function waitFor(test, timeout, step = 100) {
      return new Promise((resolve) => {
        const start = performance.now();
        const tick = () => {
          let value = null;
          try {
            value = test();
          } catch (e) {
            value = null;
          }
          if (value) return resolve(value);
          if (performance.now() - start >= timeout) return resolve(null);
          setTimeout(tick, step);
        };
        tick();
      });
    }

    function pause(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }

    /* Lexical מקשיב ל-beforeinput: הכנסת טקסט ומחיקה עוברות דרכו (execCommand לבדו לא עבד במובייל) */
    function editorInput(editor, init) {
      const win = editor.ownerDocument.defaultView;
      try {
        win.focus();
      } catch (e) { /* פריים בלי focus */ }
      editor.focus();
      editor.dispatchEvent(new win.InputEvent('beforeinput', Object.assign({ bubbles: true, cancelable: true, composed: true }, init)));
    }

    async function clearEditor(editor) {
      const doc = editor.ownerDocument;
      const range = doc.createRange();
      range.selectNodeContents(editor);
      const selection = doc.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      doc.dispatchEvent(new doc.defaultView.Event('selectionchange'));
      await pause(60);
      editorInput(editor, { inputType: 'deleteContentBackward' });
      await pause(120);
      return !editor.textContent.trim();
    }

    async function typeInto(editor, text) {
      editorInput(editor, { inputType: 'insertText', data: text });
      if (await waitFor(() => editor.textContent.trim() === text.trim(), 600, 60)) return true;
      /* גיבוי: execCommand (עובד בדסקטופ) · קודם מנקים כדי שלא ייכנס פעמיים */
      await clearEditor(editor);
      const doc = editor.ownerDocument;
      try {
        doc.execCommand('insertText', false, text);
      } catch (e) { /* לא נתמך */ }
      return Boolean(await waitFor(() => editor.textContent.trim() === text.trim(), 600, 60));
    }

    function isShown(el) {
      if (!el) return false;
      const rect = el.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return false;
      if (rect.right <= 0 || rect.bottom <= 0 || rect.left >= window.innerWidth || rect.top >= window.innerHeight) return false;
      const style = getComputedStyle(el);
      return style.visibility !== 'hidden' && style.display !== 'none' && parseFloat(style.opacity || '1') > 0.05;
    }

    function messengerFrameOpen() {
      return isShown(document.querySelector('iframe[name="intercom-messenger-frame"]'));
    }

    /* בדיקת "עסוק" אחת לכל האלמנטים היזומים (snippets/glow-attention.liquid). overlayReason = רק מה שמכסה
       את המסך עכשיו (timing: false), לשימוש כשהפתיח כבר גלוי. gateReason = גם התור, הקירור וההוספה לעגלה,
       לפני שהפתיח מוצג. הגוף הישן נשאר כגיבוי למקרה שהמתאם חסר בדף. */
    function gateReason(self) {
      const att = window.GlowAttention;
      return att ? att.busyReason(self) : overlayReason(self);
    }

    function overlayReason(self) {
      const att = window.GlowAttention;
      if (att) return att.busyReason(self, { timing: false });
      const body = document.body;
      if (body.classList.contains('reveal-mobile-nav')) return 'תפריט המובייל פתוח';
      if (body.classList.contains('show-search')) return 'החיפוש פתוח';
      if (document.querySelector('.section-header--nav-open')) return 'המגה-תפריט בדסקטופ פתוח';
      if (document.querySelector('cart-drawer[open], .js-cart-drawer[open]')) return 'מגירת העגלה פתוחה';
      if (document.querySelector('#glow-a11y-panel.is-open')) return 'פאנל הנגישות פתוח';
      if (document.querySelector('.js-overlay.is-visible')) return 'שכבת overlay של התמה פתוחה';
      if (isShown(document.getElementById('shopify-pc__banner')) || isShown(document.getElementById('shopify-pc__prefs'))) return 'באנר קוקיז (Shopify privacy) פתוח';
      if (isShown(document.querySelector('iframe[name="intercom-notification-stack-frame"]'))) return 'הודעה של Intercom (notification / outbound) מוצגת';
      const dialogs = document.querySelectorAll('[role="dialog"][aria-modal="true"]:not([aria-hidden="true"]), dialog[open]');
      for (const dialog of dialogs) {
        if (self.contains(dialog)) continue;
        if (isShown(dialog)) return `דיאלוג / פופאפ פתוח (${dialog.id || dialog.className || dialog.tagName.toLowerCase()})`;
      }
      return '';
    }

    function stickyAtcTop() {
      const el = document.querySelector('sticky-atc, .sticky-atc');
      if (!el || el.classList.contains('sticky-atc--out')) return null;
      if (document.body.classList.contains('scrolled-to-bottom')) return null;
      if (!isShown(el)) return null;
      const rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight ? rect.top : null;
    }

    /* לפי סדר עדיפות, לא לפי סדר ב-DOM: querySelector על רשימה מחזיר את הראשון בדף, ואלמנט אחר עם
       .intercom-launcher (כפתור "פתחי צ'אט" בתוכן העמוד) הקדים את ה-iframe והפתיח נפל לברירת המחדל */
    function launcherRect() {
      for (const sel of ['iframe[name="intercom-launcher-frame"]', '.intercom-lightweight-app-launcher', '.intercom-launcher']) {
        for (const el of document.querySelectorAll(sel)) {
          if (isShown(el)) return el.getBoundingClientRect();
        }
      }
      return null;
    }

    function overlaps(a, b) {
      return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
    }

    function reducedMotion() {
      return REDUCED_MOTION.matches || document.documentElement.classList.contains('a11y-stop-motion');
    }

    /* L0 פעיל = אין טעם בעדשה (CSS כבר מחליף לאטום) */
    function opaqueMode() {
      if (L0_MQ.matches) return true;
      const html = document.documentElement;
      if (L0_CLASSES.some((name) => html.classList.contains(name))) return true;
      const css = window.CSS;
      return !(css && css.supports && (css.supports('backdrop-filter', 'blur(1px)') || css.supports('-webkit-backdrop-filter', 'blur(1px)')));
    }

    /* L2: Chromium בלבד. deny-list למנועים שמפרשים backdrop-filter: url() ולא מציירים (Safari, כל iOS),
       ל-Firefox, ואחריו בדיקת CSS.supports (המתכון של liquid-glass-core.js) */
    function lensEngineOk() {
      const ua = navigator.userAgent || '';
      if (/\b(Firefox|FxiOS)\//i.test(ua)) return false;
      if (/\b(CriOS|EdgiOS|OPiOS|GSA)\//i.test(ua)) return false;
      if (/iPhone|iPad|iPod/i.test(ua)) return false;
      if (/Safari\//i.test(ua) && /AppleWebKit\//i.test(ua) && !/\b(Chrome|HeadlessChrome|Chromium|Edg|OPR|SamsungBrowser)\//i.test(ua)) return false;
      const css = window.CSS;
      if (!css || !css.supports) return false;
      return css.supports('backdrop-filter', 'url("#gdo-probe")') || css.supports('-webkit-backdrop-filter', 'url("#gdo-probe")');
    }

    function yieldToMain() {
      const sched = window.scheduler;
      if (sched && typeof sched.yield === 'function') return sched.yield();
      return new Promise((resolve) => setTimeout(resolve, 0));
    }

    function px(value) {
      return `${Math.round(value * 10) / 10}px`;
    }

    function round3(value) {
      return Math.round(value * 1000) / 1000;
    }

    class GlowDanielaOpener extends HTMLElement {
      #qa = { show: false, debug: false, flat: false };
      #log = () => {};
      #visible = false;
      #messengerOpen = false;
      #acted = false;
      #boundFn = null;
      #boundFrame = null;
      #bottom = -1;
      #viewportH = -1;
      #viewportW = -1;
      #headerB = -1;
      #rafId = 0;
      #watchId = 0;
      #swipe = null;
      #timers = new Set();
      #sending = false;
      #noRoom = false;
      #lensCache = new Map();
      #lensObserver = null;
      #lensTimer = 0;
      #lensToken = 0;
      #lensDefs = null;
      #onScroll = () => this.#schedulePosition();
      #onKeydown = (event) => this.#handleKeydown(event);
      #onClick = (event) => this.#handleClick(event);
      #onPointerDown = (event) => this.#swipeStart(event);
      #onPointerMove = (event) => this.#swipeMove(event);
      #onPointerEnd = (event) => this.#swipeEnd(event);
      #onDrawerOpen = () => this.#refreshSuppression();
      #onLayoutChange = () => {
        if (!this.#visible) return;
        this.#position(true);
        this.#lensSync();
      };
      #onVisibility = null;
      #onMessengerShow = () => {
        this.#messengerOpen = true;
        this.#markDone('messenger');
        this.#log('המסנג\'ר נפתח: הפתיח נסגר ולא יחזור בעמוד הזה');
        if (this.#visible) this.#hide();
      };
      #onMessengerHide = () => {
        this.#messengerOpen = false;
      };

      connectedCallback() {
        if (this.dataset.gdoReady === '1') return;
        this.dataset.gdoReady = '1';

        dropLegacyKeys();
        this.#qa = readQaFlags();
        this.#log = makeLogger(this.#qa.debug);
        const mode = this.#qa.show ? 'QA show (מתעלם מפעם-בסשן · בלי אנליטיקס ובלי סימון סשן)' : 'רגיל';
        this.#log(`מצב: ${mode}${this.#qa.flat ? ' · flat (L1 בכוח)' : ''} · עמוד: ${this.dataset.pageType || '?'} · סדר: ${this.dataset.needOrder || '?'}`);

        if (window.self !== window.top) {
          this.#log('לא מוצג: הדף רץ בתוך iframe (עורך התמה / preview frame)');
          return;
        }
        const storageOk = storageUsable();
        if (!storageOk && !this.#qa.show) {
          this.#log('לא מוצג: sessionStorage חסום בדפדפן');
          return;
        }

        const pageViews = storageOk ? bumpPageViews() : 1;
        if (!this.#readyToRun()) return;

        this.addEventListener('click', this.#onClick);
        this.#waitForIntercom(() => this.#arm(pageViews));
      }

      disconnectedCallback() {
        for (const id of this.#timers) clearTimeout(id);
        this.#timers.clear();
        this.#stopTracking();
        this.#lensStop();
        this.removeEventListener('click', this.#onClick);
        if (this.#onVisibility) document.removeEventListener('visibilitychange', this.#onVisibility);
      }

      #markDone(reason) {
        if (this.#qa.show) return;
        const current = storage.get('sessionStorage', KEY_DONE);
        if (reason === 'messenger' && (current === 'clicked' || current === 'dismissed')) return;
        storage.set('sessionStorage', KEY_DONE, reason);
      }

      #readyToRun() {
        const done = storage.get('sessionStorage', KEY_DONE);
        if (this.#qa.show) {
          if (done) this.#log(`QA: מתעלמים מ: ${DONE_REASONS[done] || done}`);
          return true;
        }
        if (done) {
          this.#log(`לא מוצג: ${DONE_REASONS[done] || done}. סשן חדש יציג שוב. לבדיקה: ?gdo=show`);
          return false;
        }
        return true;
      }

      #later(fn, ms) {
        const id = setTimeout(() => {
          this.#timers.delete(id);
          fn();
        }, ms);
        this.#timers.add(id);
        return id;
      }

      #waitForIntercom(onReady) {
        const poll = () => {
          const state = intercomState();
          if (state === 'ready') {
            const full = document.querySelector('iframe[name="intercom-launcher-frame"]') ? 'app מלא' : 'lightweight אנונימי, ה-API זמין';
            this.#log(`Intercom מוכן (${full}) אחרי ${Math.round(performance.now() / 100) / 10} שניות`);
            onReady();
            return;
          }
          if (performance.now() >= BOOT_DEADLINE_MS) {
            this.#log(`ויתור: Intercom לא עלה במלואו תוך ${BOOT_DEADLINE_MS / 1000} שניות מטעינת הדף (${INTERCOM_STATES[state]})`);
            return;
          }
          this.#log(`ממתין: ${INTERCOM_STATES[state]}`);
          this.#later(poll, BOOT_POLL_MS);
        };
        poll();
      }

      #bindIntercom() {
        const fn = window.Intercom;
        if (typeof fn !== 'function' || fn.booted !== true) return;
        const frame = document.querySelector('iframe[name="intercom-launcher-frame"]');
        if (fn === this.#boundFn && (frame === this.#boundFrame || !frame)) return;
        const rebind = this.#boundFn !== null && (fn !== this.#boundFn || this.#boundFrame !== null);
        this.#boundFn = fn;
        this.#boundFrame = frame;
        this.#messengerOpen = messengerFrameOpen();
        intercom('onShow', this.#onMessengerShow);
        intercom('onHide', this.#onMessengerHide);
        if (rebind) this.#log('Intercom עלה מחדש (shutdown / boot של המעקף): onShow / onHide נרשמו על המופע החדש');
      }

      #arm(pageViews) {
        this.#preloadAvatar();
        this.#bindIntercom();

        const now = performance.now();
        let wait;
        if (this.#qa.show) {
          wait = Math.max(QA_MIN_WAIT_MS, QA_SHOW_AT_MS - now);
        } else if (pageViews >= 2) {
          wait = Math.max(REPEAT_VIEW_MIN_WAIT_MS, REPEAT_VIEW_AT_MS - now);
        } else {
          wait = Math.max(0, FIRST_VIEW_AT_MS - now);
        }
        this.#log(`מתוזמן: ניסיון הצגה בעוד ${Math.round(wait / 100) / 10} שניות${pageViews >= 2 && !this.#qa.show ? ' (צפייה שנייה בסשן)' : ''}`);
        this.#later(() => this.#trigger(), wait);
      }

      /* האווטאר ועיגולי הסטוריז: loading=lazy בתוך [hidden] לא נטען, ולכן עוברים ל-eager כשהפתיח מתוזמן */
      #preloadAvatar() {
        const avatar = this.querySelector('[data-gdo-avatar]');
        if (avatar && avatar.src) {
          const probe = new Image();
          probe.decoding = 'async';
          if ('fetchPriority' in probe) probe.fetchPriority = 'low';
          probe.src = avatar.src;
          avatar.loading = 'eager';
        }
        for (const gem of this.querySelectorAll('[data-gdo-gem]')) gem.loading = 'eager';
      }

      #retry(reason) {
        this.#log(`ממתין: ${reason}`);
        this.#later(() => this.#trigger(), BLOCKED_RETRY_MS);
      }

      #trigger() {
        const qa = this.#qa.show;
        if (!qa) {
          const done = storage.get('sessionStorage', KEY_DONE);
          if (done) {
            this.#log(`לא מוצג: ${DONE_REASONS[done] || done}`);
            return;
          }
        }

        this.#bindIntercom();
        if (this.#messengerOpen || messengerFrameOpen()) {
          this.#markDone('messenger');
          this.#log('לא מוצג: המסנג\'ר של Intercom פתוח');
          return;
        }

        if (document.visibilityState !== 'visible') {
          this.#log('ממתין: הטאב מוסתר (visibilityState = hidden)');
          if (!this.#onVisibility) {
            this.#onVisibility = () => {
              if (document.visibilityState !== 'visible') return;
              document.removeEventListener('visibilitychange', this.#onVisibility);
              this.#onVisibility = null;
              this.#later(() => this.#trigger(), REPEAT_VIEW_MIN_WAIT_MS);
            };
            document.addEventListener('visibilitychange', this.#onVisibility);
          }
          return;
        }

        const state = intercomState();
        if (state !== 'ready') {
          this.#retry(INTERCOM_STATES[state]);
          return;
        }
        const blocker = gateReason(this);
        if (blocker) {
          this.#retry(blocker);
          return;
        }

        this.removeAttribute('hidden');
        this.#position(true);
        const obstacle = this.#obstacleReason();
        if (obstacle) {
          this.setAttribute('hidden', '');
          this.#retry(obstacle);
          return;
        }

        const att = window.GlowAttention;
        if (att && !att.claim('opener', { force: qa })) {
          this.setAttribute('hidden', '');
          this.#retry('אלמנט יזום אחר תפס את התור');
          return;
        }

        this.#markDone('shown');
        this.#show();
        if (qa) {
          this.#log('מוצג (QA · בלי אנליטיקס, בלי סימון סשן)');
          return;
        }
        publishOncePerSession(KEY_VIEW_SENT, 'glow_opener_view', {
          page_type: this.dataset.pageType || '',
          need_order: this.dataset.needOrder || ''
        });
        this.#log('מוצג · נשלח glow_opener_view');
      }

      #show() {
        this.#visible = true;
        this.classList.remove('is-leaving', 'is-suppressed', 'is-ducked', 'is-dragging');
        this.#clearDrag();
        this.removeAttribute('hidden');
        this.#position(true);
        this.#stage();
        this.#lensSync();
        this.#startTracking();
        this.classList.add('is-visible');
        const live = this.querySelector('[data-gdo-live]');
        if (live) {
          const text = this.dataset.gdoLiveText || '';
          const at = reducedMotion() ? T_REDUCED_LIVE : T_TEXT_SEEN;
          this.#later(() => { live.textContent = text; }, at * 1000);
        }
      }

      /* ציר הזמן: אינדקס גלוי לכל גלולה, זמני is-live (לא לחיצה לפני שהיא נראית) ושכבת ה-goo */
      #stage() {
        const reduce = reducedMotion();
        const items = this.#visibleItems();
        items.forEach((item, index) => {
          const td = T_GOO + index * T_STEP;
          item.style.setProperty('--gdo-td', String(round3(td)));
          const button = item.querySelector('.gdo__glass');
          if (!button) return;
          button.classList.remove('is-live');
          this.#later(() => button.classList.add('is-live'), reduce ? 250 : (td + T_MAT) * 1000);
        });
        const close = this.querySelector('[data-gdo-close]');
        if (close) {
          close.classList.remove('is-live');
          this.#later(() => close.classList.add('is-live'), reduce ? 250 : T_X * 1000);
        }
        if (!reduce) this.#stageGoo(items);
      }

      #visibleItems() {
        return [...this.querySelectorAll('.gdo__item')].filter((item) => item.offsetParent !== null);
      }

      #stageGoo(items) {
        const goo = this.querySelector('[data-gdo-goo]');
        const card = this.querySelector('.gdo__card');
        if (!goo || !card) return;
        goo.textContent = '';
        const host = this.getBoundingClientRect();
        const box = card.getBoundingClientRect();
        const ox = host.left - 26;
        const oy = host.top - 26;
        const srcX = box.left + box.width * (this.classList.contains('gdo--left') ? 0.45 : 0.55);
        const srcY = box.top + box.height * 0.62;
        const cs = getComputedStyle(card);
        const anchor = document.createElement('i');
        anchor.className = 'gdo__anchor';
        anchor.style.cssText = `--x:${px(box.left - ox + 14)};--y:${px(box.top - oy + box.height * 0.45)};--w:${px(box.width - 28)};--h:${px(box.height * 0.5)};--rad:${cs.borderTopLeftRadius} ${cs.borderTopRightRadius} ${cs.borderBottomRightRadius} ${cs.borderBottomLeftRadius}`;
        goo.append(anchor);
        let last = T_GOO;
        items.forEach((item, index) => {
          const glass = item.querySelector('.gdo__glass');
          if (!glass) return;
          const r = glass.getBoundingClientRect();
          const td = T_GOO + index * T_STEP;
          last = td;
          const blob = document.createElement('i');
          blob.style.cssText = `--x:${px(r.left - ox)};--y:${px(r.top - oy)};--w:${px(r.width)};--h:${px(r.height)};--dx:${px(srcX - (r.left + r.width / 2))};--dy:${px(srcY - (r.top + r.height / 2))};--d:${round3(td)}s`;
          goo.append(blob);
        });
        goo.style.setProperty('--gdo-goo-dur', `${round3(last + 0.62 + 0.18 - (T_GOO - 0.04))}s`);
      }

      #hide() {
        if (!this.#visible) return;
        this.#visible = false;
        this.#swipe = null;
        window.GlowAttention?.release('opener');
        if (this.contains(document.activeElement)) document.activeElement.blur();
        this.#stopTracking();
        const reduce = reducedMotion();
        this.classList.remove('is-dragging');
        this.style.removeProperty('--gdo-drag-o');
        this.classList.add('is-leaving');
        this.#later(() => {
          if (this.#visible) return;
          this.classList.remove('is-visible', 'is-leaving', 'is-suppressed', 'is-ducked');
          this.#clearDrag();
          this.setAttribute('hidden', '');
          this.#lensStop();
        }, reduce ? 0 : LEAVE_MS);
      }

      #clearDrag() {
        this.style.removeProperty('--gdo-drag-y');
        this.style.removeProperty('--gdo-drag-o');
      }

      #startTracking() {
        window.addEventListener('scroll', this.#onScroll, { passive: true });
        window.addEventListener('resize', this.#onScroll, { passive: true });
        document.addEventListener('keydown', this.#onKeydown);
        document.addEventListener('on:cart-drawer:before-open', this.#onDrawerOpen);
        document.addEventListener('on:cart-drawer:after-close', this.#onDrawerOpen);
        NARROW.addEventListener('change', this.#onLayoutChange);
        LENS_MQ.addEventListener('change', this.#onLayoutChange);
        L0_MQ.addEventListener('change', this.#onLayoutChange);
        this.addEventListener('pointerdown', this.#onPointerDown);
        this.addEventListener('pointermove', this.#onPointerMove);
        this.addEventListener('pointerup', this.#onPointerEnd);
        this.addEventListener('pointercancel', this.#onPointerEnd);
        this.#watchId = setInterval(() => {
          this.#bindIntercom();
          this.#refreshSuppression();
          this.#schedulePosition();
        }, WATCH_MS);
      }

      #stopTracking() {
        window.removeEventListener('scroll', this.#onScroll);
        window.removeEventListener('resize', this.#onScroll);
        document.removeEventListener('keydown', this.#onKeydown);
        document.removeEventListener('on:cart-drawer:before-open', this.#onDrawerOpen);
        document.removeEventListener('on:cart-drawer:after-close', this.#onDrawerOpen);
        NARROW.removeEventListener('change', this.#onLayoutChange);
        LENS_MQ.removeEventListener('change', this.#onLayoutChange);
        L0_MQ.removeEventListener('change', this.#onLayoutChange);
        this.removeEventListener('pointerdown', this.#onPointerDown);
        this.removeEventListener('pointermove', this.#onPointerMove);
        this.removeEventListener('pointerup', this.#onPointerEnd);
        this.removeEventListener('pointercancel', this.#onPointerEnd);
        if (this.#watchId) clearInterval(this.#watchId);
        this.#watchId = 0;
        if (this.#rafId) cancelAnimationFrame(this.#rafId);
        this.#rafId = 0;
      }

      #refreshSuppression() {
        if (!this.#visible) return;
        if (this.#messengerOpen || messengerFrameOpen()) {
          this.#markDone('messenger');
          this.#log('המסנג\'ר נפתח: הפתיח נסגר');
          this.#hide();
          return;
        }
        const state = intercomState();
        const reason = overlayReason(this) || (state === 'ready' ? '' : INTERCOM_STATES[state]);
        this.classList.toggle('is-suppressed', Boolean(reason));
        this.#log(reason ? `מוסתר זמנית: ${reason}` : 'מוצג');
      }

      #schedulePosition() {
        if (this.#rafId) return;
        this.#rafId = requestAnimationFrame(() => {
          this.#rafId = 0;
          if (this.#visible) this.#position(false);
        });
      }

      #position(force) {
        const viewportH = window.innerHeight;
        const viewportW = document.documentElement.clientWidth || window.innerWidth;
        const narrow = NARROW.matches;
        let bottom = 92;
        let side = narrow ? SIDE_NARROW : 20;
        let onLeft = false;

        const launcher = launcherRect();
        if (launcher) {
          bottom = Math.round(viewportH - launcher.top + (narrow ? GAP_PX_NARROW : GAP_PX));
          onLeft = (launcher.left + launcher.right) / 2 < viewportW / 2;
          const edge = onLeft ? launcher.left : viewportW - launcher.right;
          /* מובייל: הגריד תמיד 16px מהקצוות (v3) · דסקטופ: מיושר לקצה ה-launcher */
          side = narrow ? SIDE_NARROW : Math.round(Math.min(32, Math.max(8, edge)));
        }

        const atcTop = stickyAtcTop();
        if (atcTop !== null) bottom = Math.max(bottom, Math.round(viewportH - atcTop + (narrow ? GAP_PX_NARROW : GAP_PX)));

        const nextBottom = `${bottom}px`;
        const nextSide = `${side}px`;
        if (this.style.getPropertyValue('--gdo-bottom') !== nextBottom) this.style.setProperty('--gdo-bottom', nextBottom);
        if (this.style.getPropertyValue('--gdo-side') !== nextSide) this.style.setProperty('--gdo-side', nextSide);
        const wasLeft = this.classList.contains('gdo--left');
        this.classList.toggle('gdo--left', onLeft);
        /* פינת הזנב של הבועה מתהפכת (radius), בלי שינוי גודל ש-ResizeObserver היה תופס ⇒ מפת עדשה חדשה */
        if (wasLeft !== onLeft && this.#visible) this.#lensQueue();

        /* גם כשה-header זז (גלילה לראש העמוד מעלה את התחתית שלו) מחשבים מחדש, כדי שהפתיח לא יעלה עליו */
        const headerB = this.#headerBottom(viewportH);
        if (force || bottom !== this.#bottom || viewportH !== this.#viewportH || viewportW !== this.#viewportW || headerB !== this.#headerB) {
          this.#headerB = headerB;
          this.#bottom = bottom;
          this.#viewportH = viewportH;
          this.#viewportW = viewportW;
          this.#fit(viewportH, bottom);
        }

        if (this.#visible) {
          const obstacle = this.#obstacleReason();
          this.classList.toggle('is-ducked', Boolean(obstacle));
          if (obstacle) this.#log(`מוסתר זמנית: ${obstacle}`);
        }
      }

      /* התחתית של ה-header כשהוא גלוי בחלק העליון: דביק ב-0 אחרי גלילה, או מתחת למרקיזה בראש העמוד */
      #headerBottom(viewportH) {
        const header = document.querySelector('.section-header');
        if (!header) return 0;
        const rect = header.getBoundingClientRect();
        return rect.height > 0 && rect.bottom > 0 && rect.top < viewportH / 2 ? Math.round(rect.bottom) : 0;
      }

      /* ה-FAB של הנגישות חוסם מלמעלה: חופף לפתיח לרוחב ונמצא מעל התחתית שלו. מחזיר את התחתית שלו, או 0 */
      #fabBarrier(viewportH, bottom) {
        const fab = document.getElementById('glow-a11y-fab');
        if (!fab || !isShown(fab)) return 0;
        const fabRect = fab.getBoundingClientRect();
        const me = this.getBoundingClientRect();
        const stackBottom = viewportH - bottom;
        return fabRect.left < me.right && fabRect.right > me.left && fabRect.bottom < stackBottom ? fabRect.bottom : 0;
      }

      #topLimit(viewportH, bottom) {
        let top = EDGE_PX;
        const headerBottom = this.#headerBottom(viewportH);
        if (headerBottom) top = Math.max(top, headerBottom + 8);
        const fabBottom = this.#fabBarrier(viewportH, bottom);
        if (fabBottom) top = Math.max(top, fabBottom + 8);
        return top + this.#closeOverhang();
      }

      /* ה-X (hit של 44px) בולט מעל הבועה · נכלל בתקציב הגובה כדי שלא יעלה על ה-header */
      #closeOverhang() {
        const close = this.querySelector('[data-gdo-close]');
        const card = this.querySelector('.gdo__card');
        if (!close || !card || card.offsetParent === null) return 0;
        return Math.max(0, -close.offsetTop);
      }

      /* כל האפשרויות תמיד (הכרעת עילי 03.10): בלי קיפול. אם ה-FAB של הנגישות חוסם את הגובה (במובייל הפתיח
         ברוחב מלא וה-FAB באמצע הגובה), הפתיח מצטמצם לרוחב שעוקף את ה-FAB, וה-FAB נשאר גלוי לצידו. אם גם
         אז הסט המלא לא נכנס: #noRoom, והפתיח ממתין לגובה (לא מוצג חתוך). */
      #fit(viewportH, bottom) {
        if (!this.querySelector('.gdo__list')) return;
        this.style.removeProperty('--gdo-far');
        this.classList.remove('is-beside-fab', 'is-compact');
        const roomNow = () => viewportH - bottom - this.#topLimit(viewportH, bottom);
        let room = roomNow();
        const applied = [];
        /* הנסיגות מצטברות, לפי הסדר של GdoLogic.fitSteps, עד שהסט המלא נכנס */
        const steps = GdoLogic.fitSteps(NARROW.matches, Boolean(this.#fabBarrier(viewportH, bottom)));
        for (const step of steps) {
          if (this.offsetHeight <= room) break;
          if (step === 'beside-fab') {
            const far = this.#farInsetForFab();
            if (far <= FAR_DEFAULT) continue;
            this.style.setProperty('--gdo-far', `${far}px`);
            this.classList.add('is-beside-fab');
          } else if (step === 'compact') {
            this.classList.add('is-compact');
          }
          applied.push(step === 'compact' ? 'גריד דחוס' : 'לצד ה-FAB');
          room = roomNow();
        }
        this.#noRoom = this.offsetHeight > room;
        const needs = this.querySelectorAll('.gdo__item--need').length;
        this.#log(`התאמה: כל ${needs} הגלולות · גובה ${this.offsetHeight}px מתוך ${Math.round(room)}px${applied.length ? ` · ${applied.join(' + ')}` : ''}${this.#noRoom ? ' · אין מספיק גובה, ממתין' : ''} (${NARROW.matches ? 'מובייל' : 'דסקטופ'})`);
      }

      /* הרוחב שמשאיר את ה-FAB גלוי, כשהוא בצד הרחוק של הפתיח (ה-FAB משמאל, הפתיח מעוגן לימין). 0 = לא רלוונטי */
      #farInsetForFab() {
        const fab = document.getElementById('glow-a11y-fab');
        if (!fab || !isShown(fab)) return 0;
        const viewportW = document.documentElement.clientWidth || window.innerWidth;
        const fabRect = fab.getBoundingClientRect();
        /* ה-X (hit של 44px) בולט מהבועה לצד של ה-FAB: גם הוא לא יעלה על ה-FAB */
        const card = this.querySelector('.gdo__card');
        const close = this.querySelector('[data-gdo-close]');
        let overhang = 0;
        if (card && close && card.offsetParent !== null) {
          const c = card.getBoundingClientRect();
          const x = close.getBoundingClientRect();
          const fabOnLeft = (fabRect.left + fabRect.right) / 2 < viewportW / 2;
          overhang = Math.max(0, fabOnLeft ? c.left - x.left : x.right - c.right);
        }
        return GdoLogic.farInset(fabRect, viewportW, this.classList.contains('gdo--left'), FAB_GAP + Math.ceil(overhang));
      }

      #obstacleReason() {
        if (this.#noRoom) return 'אין מספיק גובה במסך (חלון נמוך / טלפון לרוחב)';
        const parts = [this.querySelector('.gdo__msg'), this.querySelector('[data-gdo-close]'), ...this.querySelectorAll('.gdo__pill, .gdo__other')];
        const rects = parts
          .filter((el) => el && el.offsetParent !== null)
          .map((el) => el.getBoundingClientRect())
          .filter((rect) => rect.width > 0 && rect.height > 0);
        if (!rects.length) return '';

        const fab = document.getElementById('glow-a11y-fab');
        if (fab && isShown(fab)) {
          const fabRect = fab.getBoundingClientRect();
          if (rects.some((rect) => overlaps(rect, fabRect))) return 'חופף לכפתור הנגישות';
        }
        const atc = document.querySelector('form.js-product-form[data-glow-list="pdp_main"] button[name="add"]');
        if (atc && isShown(atc)) {
          const atcRect = atc.getBoundingClientRect();
          if (rects.some((rect) => overlaps(rect, atcRect))) return 'חופף לכפתור "הוספה לעגלה" הראשי';
        }
        return '';
      }

      /* ── L2 · העדשה ── */
      #lensWanted() {
        return !this.#qa.flat && LENS_MQ.matches && !opaqueMode() && lensEngineOk();
      }

      #lensSync() {
        const want = this.#visible && this.#lensWanted();
        this.classList.toggle('gdo--lens', want);
        if (!want) {
          if (this.#lensObserver) this.#lensObserver.disconnect();
          return;
        }
        if (!this.#lensObserver && 'ResizeObserver' in window) {
          this.#lensObserver = new ResizeObserver(() => this.#lensQueue());
        }
        if (this.#lensObserver) {
          this.#lensObserver.disconnect();
          for (const el of this.querySelectorAll('.gdo__glass[data-gdo-lens]')) this.#lensObserver.observe(el);
        }
        this.#lensQueue(true);
      }

      #lensStop() {
        this.#lensToken += 1;
        if (this.#lensTimer) clearTimeout(this.#lensTimer);
        this.#lensTimer = 0;
        if (this.#lensObserver) this.#lensObserver.disconnect();
      }

      #lensQueue(now = false) {
        if (this.#lensTimer) clearTimeout(this.#lensTimer);
        this.#lensTimer = setTimeout(() => {
          this.#lensTimer = 0;
          this.#lensBuild();
        }, now ? 0 : LENS_DEBOUNCE_MS);
      }

      /* מפה לכל צורה (רוחב × גובה × רדיוס × bezel), cache, ו-yield בין משטחים כדי לא לחסום את ה-main thread */
      async #lensBuild() {
        const token = ++this.#lensToken;
        if (!this.classList.contains('gdo--lens')) return;
        const started = performance.now();
        let built = 0;
        let slowest = 0;
        for (const el of this.querySelectorAll('.gdo__glass[data-gdo-lens]')) {
          if (token !== this.#lensToken || !this.#visible || !this.classList.contains('gdo--lens')) return;
          if (el.offsetParent === null) continue;
          const w = el.offsetWidth;
          const h = el.offsetHeight;
          if (w < 8 || h < 8) continue;
          const cs = getComputedStyle(el);
          const radii = [cs.borderTopLeftRadius, cs.borderTopRightRadius, cs.borderBottomRightRadius, cs.borderBottomLeftRadius].map((v) => Math.min(parseFloat(v) || 0, Math.min(w, h) / 2));
          const bezel = parseFloat(el.dataset.gdoLens) || 15;
          const key = GdoLogic.lensKey(w, h, radii, bezel, LENS_SS);
          if (el.dataset.gdoLensKey === key && el.classList.contains('is-lens')) continue;
          let entry = this.#lensCache.get(key);
          if (!entry) {
            const t0 = performance.now();
            entry = this.#lensMake(key, w, h, radii, bezel);
            slowest = Math.max(slowest, performance.now() - t0);
            if (!entry) continue;
            this.#lensCache.set(key, entry);
            built += 1;
            await yieldToMain();
            if (token !== this.#lensToken) return;
          }
          el.style.setProperty('--gdo-lens-l', `url("#${entry.id}-l")`);
          el.dataset.gdoLensKey = key;
          el.classList.add('is-lens');
        }
        if (built) this.#log(`עדשה: ${built} מפות חדשות · ${Math.round(performance.now() - started)}ms כולל yield · המשימה הארוכה ${Math.round(slowest)}ms`);
      }

      #lensMake(key, w, h, radii, bezel) {
        try {
          const map = GdoLogic.lensMap(w, h, radii, bezel, LENS_SS);
          if (!(map.max > 0)) return null;
          const canvas = document.createElement('canvas');
          canvas.width = map.width;
          canvas.height = map.height;
          const ctx = canvas.getContext('2d');
          if (!ctx) return null;
          ctx.putImageData(new ImageData(map.data, map.width, map.height), 0, 0);
          const href = canvas.toDataURL('image/png');
          const id = `gdo-lens-${key}`;
          const scale = 2 * map.max * LENS_STRENGTH;
          if (!this.#lensDefs) this.#lensDefs = this.querySelector('[data-gdo-lenses]');
          if (!this.#lensDefs) return null;
          this.#lensDefs.insertAdjacentHTML('beforeend', this.#lensFilter(`${id}-l`, href, scale));
          return { id, scale };
        } catch (e) {
          this.#log(`עדשה: נכשל (${e && e.message}) · נשארים ב-L1`);
          return null;
        }
      }

      /* שני מסלולים על אותה מפה (gen_wow.py): שפה = frost נמוך + 3 מעברי displacement (R/G/B ב-0.86/1/1.17 =
         פיזור צבע, ורק בשפה כי המפה אפס במרכז) · גוף = frost σ10/8 + אותה עדשה + עקומה רגועה. מסכת B מחברת */
      #lensFilter(id, href, scale) {
        const vivid = '<feFuncR type="linear" slope="1.04" intercept=".05"/><feFuncG type="linear" slope="1.04" intercept=".05"/><feFuncB type="linear" slope="1.04" intercept=".05"/>';
        const table = GdoLogic.calmTable();
        const calm = `<feFuncR type="table" tableValues="${table}"/><feFuncG type="table" tableValues="${table}"/><feFuncB type="table" tableValues="${table}"/>`;
        const fc = 10;
        const s = (k) => (scale * k).toFixed(1);
        return `<filter id="${id}" x="0" y="0" width="1" height="1" color-interpolation-filters="sRGB">`
          + '<feFlood flood-color="rgb(128,128,0)" result="n"/>'
          + `<feImage href="${href}" preserveAspectRatio="none" result="m0"/>`
          + '<feComposite in="m0" in2="n" operator="over" result="m"/>'
          + `<feGaussianBlur in="SourceGraphic" stdDeviation="${LENS_FROST}" edgeMode="duplicate" result="s"/>`
          + `<feGaussianBlur in="SourceGraphic" stdDeviation="${fc}" edgeMode="duplicate" result="sf"/>`
          + `<feDisplacementMap in="s" in2="m" scale="${s(0.86)}" xChannelSelector="R" yChannelSelector="G" result="dr"/>`
          + `<feDisplacementMap in="s" in2="m" scale="${s(1)}" xChannelSelector="R" yChannelSelector="G" result="dg"/>`
          + `<feDisplacementMap in="s" in2="m" scale="${s(1.17)}" xChannelSelector="R" yChannelSelector="G" result="db"/>`
          + `<feDisplacementMap in="sf" in2="m" scale="${s(1)}" xChannelSelector="R" yChannelSelector="G" result="df"/>`
          + '<feColorMatrix in="dr" type="matrix" values="1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" result="xr"/>'
          + '<feColorMatrix in="dg" type="matrix" values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0" result="xg"/>'
          + '<feColorMatrix in="db" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 1 0 0 0 0 0 1 0" result="xb"/>'
          + '<feComposite in="xr" in2="xg" operator="arithmetic" k2="1" k3="1" result="xrg"/>'
          + '<feComposite in="xrg" in2="xb" operator="arithmetic" k2="1" k3="1" result="d"/>'
          + '<feColorMatrix in="d" type="saturate" values="1.45" result="v0"/>'
          + `<feComponentTransfer in="v0" result="v">${vivid}</feComponentTransfer>`
          + `<feColorMatrix in="df" type="saturate" values="${GdoLogic.LENS.sat}" result="c0"/>`
          + `<feComponentTransfer in="c0" result="c">${calm}</feComponentTransfer>`
          + '<feColorMatrix in="m" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 2 0 -1" result="rim"/>'
          + '<feComposite in="v" in2="rim" operator="in" result="vr"/>'
          + '<feComposite in="vr" in2="c" operator="over"/>'
          + '</filter>';
      }

      /* ── swipe (מובייל): translate ו-opacity על העלים דרך custom properties, לא על ה-host (Backdrop Root) ── */
      #swipeStart(event) {
        if (event.pointerType !== 'touch' || !this.#visible || this.#acted || !NARROW.matches) return;
        const target = event.target instanceof Element ? event.target : null;
        if (!target || !target.closest('.gdo__card') || target.closest('[data-gdo-close]')) return;
        this.#swipe = { id: event.pointerId, x0: event.clientX, y0: event.clientY, dy: 0 };
        try { target.setPointerCapture(event.pointerId); } catch (e) { /* לא נתמך */ }
      }

      #swipeMove(event) {
        const swipe = this.#swipe;
        if (!swipe || event.pointerId !== swipe.id) return;
        const dx = Math.abs(event.clientX - swipe.x0);
        const dy = Math.max(0, event.clientY - swipe.y0);
        if (dx > 40 && dy < 12) {
          this.#swipeReset();
          return;
        }
        swipe.dy = dy;
        this.classList.add('is-dragging');
        this.style.setProperty('--gdo-drag-y', `${Math.round(dy)}px`);
        this.style.setProperty('--gdo-drag-o', String(Math.max(0.3, 1 - dy / 160)));
      }

      #swipeEnd(event) {
        const swipe = this.#swipe;
        if (!swipe || event.pointerId !== swipe.id) return;
        if (event.type === 'pointerup' && swipe.dy >= SWIPE_CLOSE_PX) {
          this.#swipe = null;
          this.#dismiss('swipe');
          return;
        }
        this.#swipeReset();
      }

      #swipeReset() {
        this.#swipe = null;
        this.classList.remove('is-dragging');
        this.#clearDrag();
      }

      #handleKeydown(event) {
        if (event.key !== 'Escape' || !this.#visible) return;
        if (!this.contains(document.activeElement) && overlayReason(this)) return;
        this.#dismiss('escape');
      }

      #dismiss(method) {
        if (this.#acted) return;
        this.#acted = true;
        this.#hide();
        if (this.#qa.show) {
          this.#log(`נסגר (${method} · QA · בלי סימון סשן ובלי glow_opener_dismiss)`);
          return;
        }
        this.#markDone('dismissed');
        publish('glow_opener_dismiss', {
          method,
          page_type: this.dataset.pageType || '',
          need_order: this.dataset.needOrder || ''
        });
        this.#log(`נסגר (${method}) · מוסתר עד סוף הסשן`);
      }

      #handleClick(event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const close = target.closest('[data-gdo-close]');
        if (close) {
          if (!close.classList.contains('is-live')) return;
          this.#dismiss('close');
          return;
        }

        const choice = target.closest('[data-gdo-need]');
        if (!choice || this.#acted) return;
        /* גלולה שעוד לא נראית (בתוך ציר הלידה) לא נלחצת */
        if (!choice.classList.contains('is-live')) return;
        this.#acted = true;

        const need = choice.dataset.gdoNeed || '';
        const position = parseInt(choice.dataset.gdoPos || '0', 10) || 0;
        const qa = this.#qa.show;
        this.#markDone('clicked');
        this.#hide();

        const compose = choice.hasAttribute('data-gdo-compose');
        const delivery = compose ? this.#openCompose() : this.#deliver(choice.dataset.gdoMsg || '');
        delivery.then((mode) => {
          if (qa) {
            this.#log(`נלחץ "${need}" · mode=${mode} (QA · בלי trackEvent / אנליטיקס / סימון סשן)`);
            return;
          }
          intercom('trackEvent', 'glow-opener-click', { need, mode });
          publish('glow_opener_click', {
            need,
            position,
            mode,
            page_type: this.dataset.pageType || ''
          });
          this.#log(`נלחץ "${need}" · mode=${mode} · נשלח glow_opener_click`);
        });
      }

      /* שיחה אחת: יש שיחה ⇒ שולחים לתוכה (append). אחרת / כשל לפני שליחה ⇒ שיחה חדשה (new).
         הגנה מכפילות: #sending, ואחרי לחיצה על "שלח" אף פעם לא עוברים ל-startConversation. */
      async #deliver(text) {
        if (this.#sending || !text) return 'busy';
        this.#sending = true;
        try {
          const store = messengerStore();
          const hasConversation = conversationIds(store).length > 0 || Boolean(store && store.user && store.user.hasConversations);
          if (hasConversation) {
            const result = await this.#appendToLatest(text);
            this.#log(`שיחה קיימת: ${result.state}${result.id ? ` (${result.id})` : ''}${result.reason ? ` · ${result.reason}` : ''}`);
            if (result.state === 'sent') return 'append';
            if (result.state === 'uncertain') return 'append-unconfirmed';
          }
          await this.#startNew(text);
          return 'new';
        } finally {
          this.#sending = false;
        }
      }

      /* מחזיר { state: 'sent' | 'uncertain' | 'failed', id, reason }. 'failed' = לא נשלח כלום (בטוח לעבור לחדשה) */
      async #appendToLatest(text) {
        let ids = conversationIds(messengerStore());
        if (!ids.length) {
          /* המסנג'ר עוד לא טען את הרשימה (launcher קל אחרי מעבר עמוד): פותחים את ההודעות כדי שיטען */
          intercom('showSpace', 'messages');
          ids = await waitFor(() => {
            const list = conversationIds(messengerStore());
            return list.length ? list : null;
          }, APPEND_WAIT_MS);
          if (!ids) return { state: 'failed', reason: 'רשימת השיחות לא נטענה' };
        }
        const id = latestConversation(ids);
        intercom('showConversation', id);
        const editor = await waitFor(() => {
          if (!messengerPath(messengerStore()).endsWith(`/${id}`)) return null;
          const frame = messengerFrame();
          if (!frame || frame.getBoundingClientRect().height < 100) return null;
          const doc = messengerDoc();
          return doc ? doc.querySelector(EDITOR_SEL) : null;
        }, APPEND_WAIT_MS);
        if (!editor) return { state: 'failed', id, reason: 'אין תיבת הקלדה (שיחה שאי אפשר להשיב בה, או שלא נטענה)' };
        await pause(250);
        const live = messengerDoc() && messengerDoc().querySelector(EDITOR_SEL);
        if (!live) return { state: 'failed', id, reason: 'תיבת ההקלדה נעלמה' };
        /* טיוטה של הלקוחה בתיבה: לא נוגעים בה ולא מוסיפים עליה ⇒ שיחה חדשה */
        if (live.textContent.trim()) return { state: 'failed', id, reason: 'יש טיוטה בתיבה' };
        if (!(await typeInto(live, text))) {
          await clearEditor(live);
          return { state: 'failed', id, reason: 'הטקסט לא נכנס לתיבה' };
        }
        const send = await waitFor(() => {
          const button = messengerDoc() && messengerDoc().querySelector(SEND_SEL);
          return button && !button.disabled ? button : null;
        }, 1500, 60);
        if (!send) {
          await clearEditor(live);
          return { state: 'failed', id, reason: 'כפתור השליחה לא נפתח' };
        }
        send.click();
        /* מכאן אסור לשלוח שוב: גם אם האישור לא מגיע, לא עוברים ל-startConversation */
        const sent = await waitFor(() => !live.isConnected || !live.textContent.trim(), 3000, 80);
        return { state: sent ? 'sent' : 'uncertain', id };
      }

      /* שיחה חדשה, ואז החלון חייב להציג אותה (בלי זה Intercom חוזר לשיחה הקודמת אחרי מעבר עמוד) */
      async #startNew(text) {
        const before = new Set(conversationIds(messengerStore()));
        intercom('startConversation', text);
        const fresh = await waitFor(() => {
          const store = messengerStore();
          const path = messengerPath(store);
          if (!path || path.endsWith('/new')) return null;
          const added = conversationIds(store).filter((id) => !before.has(id));
          return added.length ? latestConversation(added) : null;
        }, NEW_WAIT_MS, 150);
        if (!fresh) {
          this.#log('שיחה חדשה: לא זוהה מזהה חדש תוך הזמן (החלון נשאר כפי ש-Intercom פתח)');
          return;
        }
        if (!messengerPath(messengerStore()).endsWith(`/${fresh}`)) {
          intercom('showConversation', fresh);
          this.#log(`שיחה חדשה ${fresh}: החלון הציג שיחה אחרת, הועבר אליה`);
        } else {
          this.#log(`שיחה חדשה ${fresh}: מוצגת`);
        }
      }

      /* "משהו אחר? כתבי לי": יש שיחה ⇒ פותחים אותה (הלקוחה כותבת בה) · אין ⇒ showNewMessage כמו קודם */
      async #openCompose() {
        const store = messengerStore();
        const ids = conversationIds(store);
        if (ids.length) {
          intercom('showConversation', latestConversation(ids));
          return 'append';
        }
        if (store && store.user && store.user.hasConversations) {
          intercom('showSpace', 'messages');
          const loaded = await waitFor(() => {
            const list = conversationIds(messengerStore());
            return list.length ? list : null;
          }, APPEND_WAIT_MS);
          if (loaded) {
            intercom('showConversation', latestConversation(loaded));
            return 'append';
          }
        }
        intercom('showNewMessage');
        return 'new';
      }
    }

    customElements.define('glow-daniela-opener', GlowDanielaOpener);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glow-newsletter-popup"] && !Shopify.designMode) return;
  try {
    const GNL_KEY_PV = 'glow_nl_pv';
  const GNL_KEY_QA = 'glow_nl_qa';
  const GNL_KEY_OPENER = 'glow_opener_done';
  const GNL_OPENER_TURN = ['shown', 'dismissed', 'clicked', 'messenger'];
  const GNL_DWELL_MS = 10000;
  const GNL_EXIT_MIN_MS = 20000;
  const GNL_RETRY_MS = 2000;
  const GNL_QA_SHOW_AT_MS = 2000;
  const GNL_DESKTOP = '(min-width: 750px) and (pointer: fine)';

  function gnlGet(area, key) {
    try { return window[area].getItem(key); } catch (e) { return null; }
  }

  function gnlSet(area, key, value) {
    try { window[area].setItem(key, value); return true; } catch (e) { return false; }
  }

  function gnlIsShown(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    if (rect.right <= 0 || rect.bottom <= 0 || rect.left >= window.innerWidth || rect.top >= window.innerHeight) return false;
    const style = getComputedStyle(el);
    return style.visibility !== 'hidden' && style.display !== 'none' && parseFloat(style.opacity || '1') > 0.05;
  }

  function gnlReadQa() {
    let flags = (gnlGet('sessionStorage', GNL_KEY_QA) || '').split(' ').filter(Boolean);
    try {
      const param = new URL(window.location.href).searchParams.get('gnl');
      if (param !== null) {
        const parts = param.toLowerCase().split(/[\s,+]+/).filter(Boolean);
        if (parts.includes('off')) {
          flags = [];
        } else {
          for (const part of parts) {
            if ((part === 'show' || part === 'debug') && !flags.includes(part)) flags.push(part);
          }
        }
        if (flags.length) {
          gnlSet('sessionStorage', GNL_KEY_QA, flags.join(' '));
        } else {
          try { sessionStorage.removeItem(GNL_KEY_QA); } catch (e) { /* storage חסום */ }
        }
      }
    } catch (e) { /* URL לא תקין · נשארים עם מה שבסשן */ }
    return { show: flags.includes('show'), debug: flags.includes('debug') };
  }

  /* המתאם (snippets/glow-attention.liquid) מרונדר inline לפני הבאנדל. אם הוא חסר (דחיפה חלקית),
     הניוזלטר נשאר סגור ולא קופץ בלי תיאום. חותמת ההוספה לעגלה נרשמת במתאם. */
  function gnlAtt() {
    return window.GlowAttention || null;
  }

  class GlowNewsletterPopup extends HTMLElement {
    #storageKey = 'glow_nl_seen';
    #capMs = 30 * 24 * 60 * 60 * 1000;
    #lastFocused = null;
    #qa = { show: false, debug: false };
    #log = () => {};
    #lastLog = '';
    #timers = new Set();
    #stopped = false;
    #pending = false;
    #openerAtLoad = null;
    #dwellLeft = GNL_DWELL_MS;
    #dwellStart = 0;
    #dwellId = 0;
    #onVisibility = null;
    #onMouseOut = null;
    #noOpener = false;
    /* חיסון ירי-ליד-כפול (לקח 18.7) — דפוס PENDING+TS כמו club/wishlist/soldout */
    #leadPendingKey = 'glow_nl_lead_pending';
    #leadTsKey = 'glow_nl_lead_ts';
    #leadFreshMs = 20 * 60 * 1000;
    /* snapshot עגלה ל-ingest (תוספת 3.8, אישור עילי) — נטען בפתיחת הפופ-אפ,
       נשלח כ-detail.cart באותו פורמט של הסולד-אאוט (רינדור ב"מסע הלקוחה"). */
    #cart = null;

    connectedCallback() {
      this.overlay = this.querySelector('[data-glow-nl-overlay]');
      this.panel = this.querySelector('[data-glow-nl-panel]');

      this.querySelectorAll('[data-glow-nl-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      this.overlay?.addEventListener('click', (event) => {
        if (event.target === this.overlay) this.close();
      });

      this.addEventListener('keydown', this.#onKeydown.bind(this));

      /* Glow Customer Hub — ingest keepalive בשליחת הפופ-אפ (מקביל ל-native, לא חוסם) */
      this.querySelector('.glow-nl__form')?.addEventListener('submit', (event) => {
        /* דגל PENDING+TS: הליד ייורה ב-postback רק אם submit אמיתי קרה בסשן הזה
           (דפוס club/wishlist/soldout) — מונע ירי חוזר מ-hot-reload/F5 על ?customer_posted=true */
        try {
          sessionStorage.setItem(this.#leadPendingKey, '1');
          sessionStorage.setItem(this.#leadTsKey, String(Date.now()));
        } catch (e) { /* incognito — נשענים על fallback ה-one-shot ב-#publishLead */ }
        try {
          const emailEl = event.target.querySelector('input[name="contact[email]"]');
          if (emailEl && emailEl.value) this.#hubIngest(emailEl.value);
        } catch (e) { /* לא-חוסם את ה-native submit */ }
      });

      if (this.dataset.posted === 'true') {
        this.#markSeen();
        this.#publishLead();
        this.open();
        return;
      }

      this.#qa = gnlReadQa();
      this.#log = (message) => {
        if (!this.#qa.debug || message === this.#lastLog) return;
        this.#lastLog = message;
        try { console.info(`[glow-nl] ${message}`); } catch (e) { /* אין קונסול */ }
      };

      const pv = (parseInt(gnlGet('sessionStorage', GNL_KEY_PV) || '0', 10) || 0) + 1;
      gnlSet('sessionStorage', GNL_KEY_PV, String(pv));
      this.#openerAtLoad = gnlGet('sessionStorage', GNL_KEY_OPENER);
      this.#log(`מצב: ${this.#qa.show ? 'QA show (עוקף שערים, בלי cap)' : 'רגיל'} · צפייה ${pv} בסשן · פתיח בטעינה: ${this.#openerAtLoad || 'עוד לא'}`);

      if (this.#qa.show) {
        this.#later(() => this.#attempt('qa'), Math.max(400, GNL_QA_SHOW_AT_MS - performance.now()));
        return;
      }

      if (!gnlAtt()) {
        this.#log('לא מוצג: מתאם הקפיצות (glow-attention) חסר בדף');
        return;
      }
      if (this.#seen()) {
        this.#log('לא מוצג: כבר נסגר או נרשמה ב-30 הימים האחרונים (glow_nl_seen). לאיפוס: ?gnl=reset · לבדיקה: ?gnl=show');
        return;
      }
      const skip = this.#sessionSkipReason();
      if (skip) {
        this.#log(`לא מוצג בסשן הזה: ${skip}`);
        return;
      }

      /* הפתיח מרונדר ב-theme.liquid אחרי הניוזלטר, ולכן בדיקת קיומו מחכה ל-DOMContentLoaded. */
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.#decide(pv), { once: true });
      } else {
        this.#decide(pv);
      }
    }

    #decide(pv) {
      if (this.#stopped) return;
      if (gnlAtt().chatSeenThisView()) {
        this.#log('המסנג\'ר של דניאלה היה פתוח בצפייה הזו: הניוזלטר זכאי מהצפייה הבאה');
        this.#stop();
        return;
      }
      this.#noOpener = !document.querySelector('glow-daniela-opener');
      if (this.#noOpener) {
        this.#log('אין פתיח של דניאלה בדף: מתעלמים מתנאי הפתיח');
        if (pv >= 2) {
          this.#log('עמוד זכאי: צפייה שנייה ומעלה (בלי פתיח)');
          this.#startDwell();
        } else {
          this.#log('עמוד ראשון בסשן: הטיימר לא רץ');
        }
      } else {
        const openerTurnTaken = GNL_OPENER_TURN.includes(this.#openerAtLoad);
        if (pv >= 2 && openerTurnTaken) {
          this.#log('עמוד זכאי: צפייה שנייה ומעלה, ולפתיח כבר היה התור שלו בעמוד קודם');
          this.#startDwell();
        } else if (pv >= 3 && !this.#openerAtLoad) {
          this.#log('עמוד זכאי (fallback): צפייה שלישית ומעלה והפתיח מעולם לא סומן בסשן');
          this.#startDwell();
        } else if (pv < 2) {
          this.#log('עמוד ראשון בסשן: הטיימר לא רץ (החלון הזה שייך לפתיח של דניאלה)');
        } else {
          this.#log('צפייה שנייה, אבל הפתיח עוד לא קיבל את התור שלו: מחכים לעמוד הבא');
        }
      }

      if (window.matchMedia(GNL_DESKTOP).matches) {
        this.#onMouseOut = (event) => this.#handleExit(event);
        document.addEventListener('mouseout', this.#onMouseOut);
        this.#log(this.#noOpener
          ? 'דסקטופ: exit intent פעיל (אחרי 20 שניות בעמוד · אין פתיח בדף)'
          : 'דסקטופ: exit intent פעיל (אחרי 20 שניות בעמוד, כשלפתיח כבר היה התור שלו)');
      }
    }

    disconnectedCallback() {
      this.#stop();
    }

    #later(fn, ms) {
      const id = setTimeout(() => {
        this.#timers.delete(id);
        fn();
      }, ms);
      this.#timers.add(id);
      return id;
    }

    #stop() {
      this.#stopped = true;
      for (const id of this.#timers) clearTimeout(id);
      this.#timers.clear();
      if (this.#onVisibility) document.removeEventListener('visibilitychange', this.#onVisibility);
      if (this.#onMouseOut) document.removeEventListener('mouseout', this.#onMouseOut);
      this.#onVisibility = null;
      this.#onMouseOut = null;
    }

    /* 10 שניות של זמן גלוי: הטיימר נעצר כשהטאב מוסתר וממשיך מאותה נקודה כשהוא חוזר. */
    #startDwell() {
      this.#onVisibility = () => this.#syncDwell();
      document.addEventListener('visibilitychange', this.#onVisibility);
      this.#syncDwell();
    }

    #syncDwell() {
      if (this.#stopped || this.#pending) return;
      if (document.visibilityState === 'visible') {
        if (this.#dwellId) return;
        this.#dwellStart = performance.now();
        this.#log(`טיימר זמן-גלוי רץ: עוד ${Math.round(this.#dwellLeft / 100) / 10} שניות`);
        this.#dwellId = this.#later(() => {
          this.#dwellId = 0;
          this.#dwellLeft = 0;
          this.#attempt('dwell');
        }, this.#dwellLeft);
        return;
      }
      if (!this.#dwellId) return;
      clearTimeout(this.#dwellId);
      this.#timers.delete(this.#dwellId);
      this.#dwellId = 0;
      this.#dwellLeft = Math.max(0, this.#dwellLeft - (performance.now() - this.#dwellStart));
      this.#log(`הטאב מוסתר: הטיימר נעצר (נשארו ${Math.round(this.#dwellLeft / 100) / 10} שניות)`);
    }

    #handleExit(event) {
      if (this.#stopped || this.#pending || !this.hidden) return;
      if (event.relatedTarget !== null || event.clientY > 0) return;
      const opener = gnlGet('sessionStorage', GNL_KEY_OPENER);
      if (!this.#noOpener && !GNL_OPENER_TURN.includes(opener)) {
        this.#log('exit intent נדחה: הפתיח עוד לא קיבל את התור שלו');
        return;
      }
      if (performance.now() < GNL_EXIT_MIN_MS) {
        this.#log(`exit intent נדחה: רק ${Math.round(performance.now() / 1000)} שניות בעמוד (נדרשות 20)`);
        return;
      }
      const att = gnlAtt();
      if (att.chatSeenThisView()) {
        this.#log('exit intent נדחה: המסנג\'ר היה פתוח בצפייה הזו (זכאי מהעמוד הבא)');
        this.#stop();
        return;
      }
      /* עסוק ברגע היציאה = היציאה לא נספרת. בלי לולאת המתנה, כדי שהפופאפ לא יקפוץ מאוחר כשהיא כבר חזרה לדף. */
      const busy = this.#busyReason();
      if (busy) {
        this.#log(`exit intent נדחה: ${busy}`);
        return;
      }
      this.#log('exit intent: העכבר יצא מהחלון למעלה');
      this.#attempt('exit');
    }

    #sessionSkipReason() {
      if (gnlGet('sessionStorage', 'glow_rescue_shown')) return 'פופאפ הצלת העגלה כבר הוצג בסשן הזה';
      if (gnlGet('localStorage', 'glow_known_email')) return 'יש מייל מוכר בדפדפן (glow_known_email)';
      return '';
    }

    /* בדיקת "עסוק" אחת לכל האלמנטים היזומים: GlowAttention.busyReason (snippets/glow-attention.liquid). */
    #busyReason() {
      const att = gnlAtt();
      return att ? att.busyReason(this) : '';
    }

    #attempt(source) {
      if (this.#stopped || !this.hidden) return;
      this.#pending = true;
      const qa = source === 'qa';
      if (!qa) {
        if (this.#seen()) {
          this.#log('לא מוצג: ה-cap של 30 יום הופעל בינתיים');
          this.#stop();
          return;
        }
        const skip = this.#sessionSkipReason();
        if (skip) {
          this.#log(`לא מוצג בסשן הזה: ${skip}`);
          this.#stop();
          return;
        }
        if (gnlAtt().chatSeenThisView()) {
          this.#log('המסנג\'ר של דניאלה נפתח בצפייה הזו: הניוזלטר זכאי מהצפייה הבאה, אחרי 10 שניות גלויות');
          this.#stop();
          return;
        }
        if (source === 'dwell' && !this.#noOpener) {
          const openerNow = gnlGet('sessionStorage', GNL_KEY_OPENER);
          const hadTurn = GNL_OPENER_TURN.includes(this.#openerAtLoad);
          if (!hadTurn && GNL_OPENER_TURN.includes(openerNow)) {
            this.#log('הפתיח קיבל את התור שלו בצפייה הזו: הניוזלטר מחכה לעמוד הבא (אף פעם לא שניהם באותה צפייה)');
            this.#stop();
            return;
          }
        }
      }
      if (document.visibilityState !== 'visible') {
        this.#log('ממתין: הטאב מוסתר');
        this.#later(() => this.#attempt(source), GNL_RETRY_MS);
        return;
      }
      const busy = this.#busyReason();
      if (busy) {
        this.#log(`ממתין: ${busy} · ניסיון נוסף בעוד 2 שניות`);
        this.#later(() => this.#attempt(source), GNL_RETRY_MS);
        return;
      }
      this.#log(`מוצג (${source === 'qa' ? 'QA' : source === 'exit' ? 'exit intent' : '10 שניות זמן-גלוי'})`);
      this.#stop();
      this.open(qa);
    }

    #seen() {
      try {
        const raw = localStorage.getItem(this.#storageKey);
        if (!raw) return false;
        return Date.now() - parseInt(raw, 10) < this.#capMs;
      } catch (error) {
        return false;
      }
    }

    #markSeen() {
      try {
        localStorage.setItem(this.#storageKey, String(Date.now()));
      } catch (error) {
        /* localStorage unavailable - fail silently */
      }
    }

    /* Glow Customer Hub — fire-and-forget keepalive fetch ל-Worker (origin:'popup').
       ה-native submit ממשיך כרגיל; זו תוספת מקבילה שעוקפת את באג ה-note-invalid. */
    #hubIngest(email) {
      try {
        if (!email) return;
        const url = 'https://glow-customer-hub.glowvitamininsights.workers.dev/ingest';
        /* sendBeacon + Blob text/plain = simple request (בלי CORS preflight) ששורד ניווט-דף —
           הדפוס המוכח של glow-consent-beacon (תוקן 3.8: fetch+json נהרג עם ה-navigation). */
        const detail = { origin: 'popup' };
        const c = this.#cart;
        if (c && c.items && c.items.length) {
          detail.cart = {
            items: c.items.map((i) => ({
              title: i.product_title, qty: i.quantity,
              line_price: Math.round((typeof i.final_line_price === 'number') ? i.final_line_price : (i.line_price || 0)) / 100,
              unit_price: Math.round((typeof i.final_price === 'number') ? i.final_price : (i.price || 0)) / 100
            })),
            count: c.item_count,
            subtotal: Math.round(c.items_subtotal_price || 0) / 100,
            original_total: Math.round(c.original_total_price || 0) / 100,
            discount: Math.round(c.total_discount || 0) / 100,
            total: Math.round(c.total_price || 0) / 100,
            currency: c.currency || 'ILS'
          };
        }
        const payload = new Blob([JSON.stringify({ email: email, source: 'newsletter', detail: detail })], { type: 'text/plain' });
        let sent = false;
        try { sent = !!(navigator.sendBeacon && navigator.sendBeacon(url, payload)); } catch (err) { sent = false; }
        if (!sent) {
          fetch(url, { method: 'POST', keepalive: true, mode: 'no-cors', body: payload }).catch(() => {});
        }
      } catch (error) { /* לעולם לא שובר את הפופאפ */ }
    }

    /* אנליטיקה בלבד — glow_lead (source:'newsletter') בהרשמה מוצלחת.
       חיסון ירי-כפול (לקח 18.7): data-posted נגזר מ-form.posted_successfully? שנשאר true
       בכל render של URL עם ?customer_posted=true. hot-reload/F5 חיברו מחדש את הרכיב וירו
       glow_lead שוב ושוב (9,244 אירועי-זבל ב-17.7). לכן הירי מותנה כמו club/wishlist/soldout:
       PENDING טרי שנקבע רק ב-submit אמיתי בסשן זה, ומנוקה *לפני* הירי. fallback ל-one-shot
       על window אם sessionStorage חסום (incognito). guard מלא — לעולם לא שובר את הפופאפ. */
    #publishLead() {
      let ok = false;
      try {
        const pending = sessionStorage.getItem(this.#leadPendingKey) === '1';
        const ts = parseInt(sessionStorage.getItem(this.#leadTsKey) || '0', 10);
        sessionStorage.removeItem(this.#leadPendingKey);
        sessionStorage.removeItem(this.#leadTsKey);
        ok = pending && ts > 0 && (Date.now() - ts) <= this.#leadFreshMs;
      } catch (error) {
        /* sessionStorage חסום — fallback: לירות פעם אחת בלבד לכל טעינת-דף */
        if (window.__glowNlLeadFired) return;
        ok = true;
      }
      if (!ok) return;
      window.__glowNlLeadFired = true;
      if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
      try {
        window.Shopify.analytics.publish('glow_lead', { source: 'newsletter' });
      } catch (error) {
        /* אנליטיקה לא-קריטית */
      }
    }

    #focusable() {
      return Array.from(
        this.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => el.offsetParent !== null);
    }

    #onKeydown(event) {
      if (this.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key !== 'Tab') return;

      const items = this.#focusable();
      if (items.length === 0) return;
      const first = items[0];
      const last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    open(force = false) {
      if (!this.hidden) return;
      /* אין שני פופאפים באותו ביקור (החלטת עילי 19.8): אם פופאפ הצלת-העגלות פתוח
         או שכבר הוצג בסשן הזה · המועדון מוותר בשקט (בלי לקבוע frequency cap).
         force = מצב QA (?gnl=show) בלבד, עוקף את השער. */
      if (!force) {
        try {
          const rescue = document.querySelector('glow-cart-rescue');
          if (rescue && !rescue.hidden) return;
          if (sessionStorage.getItem('glow_rescue_shown')) return;
        } catch (e) { /* לא-קריטי */ }
      }
      /* R1 + R4 במתאם: תור יחיד, והתראות Intercom וה-launcher מוסתרים כל עוד המודאל פתוח.
         force (QA / הודעת הצלחה אחרי הרשמה) תופס את התור גם כשאחר מחזיק בו. */
      const att = gnlAtt();
      if (att && !att.claim('newsletter', { modal: true, force })) return;
      this.#lastFocused = document.activeElement;
      this.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      /* preload עגלה ל-detail.cart של ה-ingest (fire-and-forget, לא חוסם) */
      try {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => (r.ok ? r.json() : null))
          .then((c) => { if (c) this.#cart = c; })
          .catch(() => {});
      } catch (error) { /* לא-קריטי */ }

      requestAnimationFrame(() => {
        const items = this.#focusable();
        if (items.length > 0) items[0].focus();
        else this.panel?.focus();
      });
    }

    close() {
      if (this.hidden) return;
      this.hidden = true;
      document.documentElement.style.overflow = '';
      gnlAtt()?.release('newsletter');
      if (!this.#qa.show) this.#markSeen();
      if (this.#lastFocused && typeof this.#lastFocused.focus === 'function') {
        this.#lastFocused.focus();
      }
    }
  }

  if (!customElements.get('glow-newsletter-popup')) {
    customElements.define('glow-newsletter-popup', GlowNewsletterPopup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glow-page-heading"] && !Shopify.designMode) return;
  try {
    /* glow-legal-page — מפעיל את תוכן-העניינים (data-scroll-to) בעמודי המדיניות
     העצמאיים (/pages/terms, /pages/privacy). ב-Help Hub המאזין יושב על
     <glow-help-hub>; מחוץ לו כפתורי ה-ToC היו מתים. אותה התנהגות בדיוק:
     scrollIntoView + כיבוד prefers-reduced-motion + העברת פוקוס ליעד. */
  class GlowLegalPage extends HTMLElement {
    connectedCallback() {
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.onScrollToClick = this.onScrollToClick.bind(this);
      this.addEventListener('click', this.onScrollToClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onScrollToClick);
    }

    onScrollToClick(event) {
      const trigger = event.target.closest('[data-scroll-to]');
      if (!trigger || !this.contains(trigger)) return;
      const target = this.querySelector('#' + CSS.escape(trigger.dataset.scrollTo));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({
        block: 'start',
        behavior: this.reduceMotion ? 'auto' : 'smooth'
      });
      if (typeof target.focus === 'function') {
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    }
  }

  if (!customElements.get('glow-legal-page')) {
    customElements.define('glow-legal-page', GlowLegalPage);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    /* Glow Customer Hub — ingest keepalive (מקביל ל-native, לא חוסם). window-guarded.
     מכסה את כל מופעי .signup-form: פוטר (footer) + דף-הבית (home) + pop-up snippet. */
  window.glowHubIngest = window.glowHubIngest || function (email, source, detail) {
    try {
      if (!email && source !== 'checkout') return; /* checkout מותר אנונימי — יומן העגלות */
      /* זיכרון-מייל (כוונת-רכש): הרשמה מזוהה → הדפדפן זוכר, ולחיצת "לתשלום" עתידית
         תיקשר למסע הלקוחה גם בלי מייל בצ'קאאוט. localStorage בלבד, לא נשלח לצד-שלישי. */
      try {
        if (email && /\S+@\S+\.\S+/.test(email)) localStorage.setItem('glow_known_email', String(email).trim().toLowerCase());
      } catch (err) { /* private mode */ }
      var url = 'https://glow-customer-hub.glowvitamininsights.workers.dev/ingest';
      /* sendBeacon + Blob text/plain = simple request (בלי CORS preflight) ששורד ניווט-דף —
         הדפוס המוכח של glow-consent-beacon (תוקן 3.8: fetch+json נהרג עם ה-navigation). */
      var payload = new Blob([JSON.stringify({ email: email, source: source, detail: detail || {} })], { type: 'text/plain' });
      var sent = false;
      try { sent = !!(navigator.sendBeacon && navigator.sendBeacon(url, payload)); } catch (err) { sent = false; }
      if (!sent) {
        fetch(url, { method: 'POST', keepalive: true, mode: 'no-cors', body: payload }).catch(function () {});
      }
    } catch (e) {}
  };

  /* snapshot עגלה ל-ingest (תוספת 3.8, אישור עילי): נטען על focus בטופס (throttle 10ש'),
     נשלח כ-detail.cart באותו פורמט של הסולד-אאוט — ה-Hub מרנדר אותו ב"מסע הלקוחה". */
  window.glowNlCart = window.glowNlCart || { c: null, ts: 0 };
  window.glowCartSummary = window.glowCartSummary || function (c) {
    var items = (c.items || []).map(function (i) {
      var lineCents = (typeof i.final_line_price === 'number') ? i.final_line_price
        : (typeof i.line_price === 'number') ? i.line_price : 0;
      var unitCents = (typeof i.final_price === 'number') ? i.final_price
        : (typeof i.price === 'number') ? i.price : 0;
      return { title: i.product_title, qty: i.quantity,
        line_price: Math.round(lineCents) / 100, unit_price: Math.round(unitCents) / 100 };
    });
    return { items: items, count: c.item_count,
      subtotal: Math.round(c.items_subtotal_price || 0) / 100,
      original_total: Math.round(c.original_total_price || 0) / 100,
      discount: Math.round(c.total_discount || 0) / 100,
      total: Math.round(c.total_price || 0) / 100,
      currency: c.currency || 'ILS' };
  };
  document.addEventListener('focusin', function (e) {
    try {
      if (!e.target || !e.target.closest || !e.target.closest('.signup-form form')) return;
      if (Date.now() - window.glowNlCart.ts < 10000) return;
      window.glowNlCart.ts = Date.now();
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) window.glowNlCart.c = c; })
        .catch(function () {});
    } catch (err) { /* לא-קריטי */ }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches || !form.matches('.signup-form form')) return;

    /* Glow Customer Hub — הרשמה לניוזלטר. origin נגזר מ-id הטופס. */
    try {
      const emailEl = form.querySelector('input[name="contact[email]"]');
      if (emailEl && emailEl.value) {
        const id = form.id || '';
        const origin = id.indexOf('footer') !== -1 ? 'footer'
          : id.indexOf('home') !== -1 ? 'home' : 'popup';
        const nlDetail = { origin: origin };
        const nlCart = window.glowNlCart.c;
        if (nlCart && nlCart.items && nlCart.items.length) nlDetail.cart = window.glowCartSummary(nlCart);
        window.glowHubIngest(emailEl.value, 'newsletter', nlDetail);
      }
    } catch (e) { /* לא-חוסם את ה-native submit */ }

    const consentCheckbox = form.querySelector('[data-marketing-consent]');
    const tagsInput = form.querySelector('input[name="contact[tags]"]');
    if (!tagsInput) return;

    const consentTag = consentCheckbox && consentCheckbox.checked ? 'marketing:yes' : 'marketing:no';
    const tags = tagsInput.value
      .split(',')
      .map((tag) => tag.trim())
      .filter(Boolean)
      .filter((tag) => tag !== 'marketing:yes' && tag !== 'marketing:no');
    tags.push(consentTag);
    tagsInput.value = tags.join(', ');
  }, true);
  } catch(e) { console.error(e); }
})();

})();
